
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("jsuJ9", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $cbY7C = parcelRequire("cbY7C");


var $9kbTQ = parcelRequire("9kbTQ");


var $bB0i2 = parcelRequire("bB0i2");


var $6JrSr = parcelRequire("6JrSr");


var $jyAY3 = parcelRequire("jyAY3");


var $kgGsB = parcelRequire("kgGsB");


var $iDrrr = parcelRequire("iDrrr");


var $4QfFX = parcelRequire("4QfFX");


var $4Vdlk = parcelRequire("4Vdlk");


var $cUdy2 = parcelRequire("cUdy2");


var $cIWiw = parcelRequire("cIWiw");


var $fGXGw = parcelRequire("fGXGw");


var $lpNn5 = parcelRequire("lpNn5");


var $6sD11 = parcelRequire("6sD11");


var $9GVkD = parcelRequire("9GVkD");


var $1fHIr = parcelRequire("1fHIr");


var $liCgE = parcelRequire("liCgE");


var $bqqhM = parcelRequire("bqqhM");


var $7uL08 = parcelRequire("7uL08");


var $j6GCu = parcelRequire("j6GCu");


var $6ZWGn = parcelRequire("6ZWGn");


var $aLgN8 = parcelRequire("aLgN8");


var $1NH4A = parcelRequire("1NH4A");


var $eoCwK = parcelRequire("eoCwK");


var $kdCH7 = parcelRequire("kdCH7");


var $eMMLI = parcelRequire("eMMLI");

function $aa50747aa4702ef1$var$signPanelSplitterDragData(data) {
    return {
        ...data,
        [(0, $eMMLI.panelSplitterDragDataSymbol)]: true
    };
}
const $aa50747aa4702ef1$var$containerStyles = {
    root: "_2xIroY98eZ _497WNwYbGa _2zndICT6kp _3iDTPbYbGa _1mT5xdWVPG _1ZB6UydnbC _2I62gzdnbC _42Yu6B7dHp _2UeR8bvLZJ",
    positionEnd: "_1OKFqYJg58",
    positionStart: "_3iC0zd1x6F"
};
const $aa50747aa4702ef1$var$grabAreaStyles = {
    root: "_39xV02vFgp _0jFU0VN91d _1mT5xdWVPG _46hvQmPgdg _03SyCPPgdg _0xmtkoPgdg _0LQT5EPgdg _1UtDYzjOvk _0KLXrujOvk _3Z9K0wb8VS _3OZqoK0jWM _0qk6IKN8t6 _1kOSYtWkA1 _0ReiIHuudW _25IEJJjTy9 _0clgaMjTy9 _3sFUREYbGa _0CMRbkAwSC",
    fullHeightSidebar: "_0ReiIHYNYw"
};
const $aa50747aa4702ef1$var$lineStyles = {
    root: "_1mT5xdWVPG _3iDTPbvLZJ _39xV024Y4b _0jFU0VN91d _1UtDYzOLYo _0KLXru98eZ _3iC0zdXJux"
};
const $aa50747aa4702ef1$var$tooltipStyles = {
    root: "_0GTcwRTUhv _39xV02W9qI"
};
const $aa50747aa4702ef1$var$PanelSplitterTooltip = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(18);
    let children;
    let className;
    let props;
    if ($[0] !== t0) {
        ({ children: children, className: className, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = className;
        $[3] = props;
    } else {
        children = $[1];
        className = $[2];
        props = $[3];
    }
    let t1;
    bb0: {
        if (!props.style || !props.style.transform) {
            t1 = props.style;
            break bb0;
        }
        let t2;
        if ($[4] !== props.style.transform) {
            let t3;
            if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
                t3 = /(?:-|\+)?\d*\.?\d+px/g;
                $[6] = t3;
            } else t3 = $[6];
            t2 = props.style.transform.matchAll(t3);
            $[4] = props.style.transform;
            $[5] = t2;
        } else t2 = $[5];
        const [translateX, translateY] = t2;
        if (!translateY) {
            t1 = props.style;
            break bb0;
        }
        const newTranslateY = `max(calc(${(0, $liCgE.contentInsetBlockStart)} + ${"var(--ds-space-100, 8px)"}), ${translateY})`;
        const newTransform = `translate3d(${translateX}, ${newTranslateY}, 0)`;
        let t3;
        if ($[7] !== newTransform || $[8] !== props.style) {
            t3 = {
                ...props.style,
                transform: newTransform
            };
            $[7] = newTransform;
            $[8] = props.style;
            $[9] = t3;
        } else t3 = $[9];
        t1 = t3;
    }
    const style = t1;
    let t2;
    if ($[10] !== className) {
        t2 = (0, $hekY6.default)([
            $aa50747aa4702ef1$var$tooltipStyles.root,
            className
        ]);
        $[10] = className;
        $[11] = t2;
    } else t2 = $[11];
    let t3;
    if ($[12] !== children || $[13] !== props || $[14] !== ref || $[15] !== style || $[16] !== t2) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $6sD11.default), {
            ...props,
            ref: ref,
            className: t2,
            style: style
        }, children);
        $[12] = children;
        $[13] = props;
        $[14] = ref;
        $[15] = style;
        $[16] = t2;
        $[17] = t3;
    } else t3 = $[17];
    return t3;
} : ({ children: children, className: className, ...props }, ref)=>{
    const style = (0, $cozmU.useMemo)(()=>{
        if (!props.style || !props.style.transform) return props.style;
         // We cannot just match against integers safely, as browsers may introduce non-integer values due to scaling
        // In the future we can probably use `CSSStyleValue.parse()` to get the browser to handle parsing for us,
        // but there's no Firefox support yet.
        const [translateX, translateY] = props.style.transform.matchAll(/(?:-|\+)?\d*\.?\d+px/g);
        if (!translateY) // If we can't extract the translateY value we bail out and return the original style
        return props.style;
         /**
       * Adjusts the translate Y to keep the tooltip within the main content area,
       * so that it does not appear over the banner or top navigation.
       */ 
        const newTranslateY = `max(calc(${(0, $liCgE.contentInsetBlockStart)} + ${"var(--ds-space-100, 8px)"}), ${translateY})`;
        const newTransform = `translate3d(${translateX}, ${newTranslateY}, 0)`;
        return {
            ...props.style,
            transform: newTransform
        };
    }, [
        props.style
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $6sD11.default), {
        ...props,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $hekY6.default)([
            $aa50747aa4702ef1$var$tooltipStyles.root,
            className
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style
    }, children);
}); /**
     * A wrapper component that renders a tooltip if the tooltipContent or shortcut is provided.
     */ 
const $aa50747aa4702ef1$var$MaybeTooltip = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { tooltipContent: tooltipContent, shortcut: shortcut, children: children, testId: testId } = t0;
    const isFhsEnabled = (0, $1fHIr.useIsFhsEnabled)();
    if (tooltipContent && (isFhsEnabled || (0, $iDrrr.fg)("platform-dst-keep-desired-fhs-features"))) {
        let t1;
        if ($[0] !== children || $[1] !== shortcut || $[2] !== testId || $[3] !== tooltipContent) {
            t1 = /*#__PURE__*/ $cozmU.createElement((0, $lpNn5.default), {
                testId: testId,
                content: tooltipContent,
                shortcut: shortcut,
                position: "mouse-y",
                mousePosition: "right",
                isScreenReaderAnnouncementDisabled: true,
                component: $aa50747aa4702ef1$var$PanelSplitterTooltip,
                shouldAlwaysFadeIn: true,
                shouldRenderToParent: true
            }, children);
            $[0] = children;
            $[1] = shortcut;
            $[2] = testId;
            $[3] = tooltipContent;
            $[4] = t1;
        } else t1 = $[4];
        return t1;
    }
    return children;
} : ({ tooltipContent: tooltipContent, shortcut: shortcut, children: children, testId: testId })=>{
    const isFhsEnabled = (0, $1fHIr.useIsFhsEnabled)();
    if (tooltipContent && (isFhsEnabled || (0, $iDrrr.fg)('platform-dst-keep-desired-fhs-features'))) return /*#__PURE__*/ $cozmU.createElement((0, $lpNn5.default), {
        testId: testId,
        content: tooltipContent,
        shortcut: shortcut,
        position: "mouse-y",
        mousePosition: "right",
        isScreenReaderAnnouncementDisabled: true,
        component: $aa50747aa4702ef1$var$PanelSplitterTooltip,
        shouldAlwaysFadeIn: true,
        shouldRenderToParent: true
    }, children);
    return children;
};
function $aa50747aa4702ef1$var$getTextDirection(element) {
    const { direction: direction } = window.getComputedStyle(element);
    return direction === 'rtl' ? 'rtl' : 'ltr';
}
const $aa50747aa4702ef1$var$PortaledPanelSplitter = ({ label: label, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, testId: testId, panelId: panelId, panelWidth: panelWidth, onCompleteResize: onCompleteResize, getResizeBounds: getResizeBounds, panel: panel, portal: portal, resizingCssVar: resizingCssVar, position: position, tooltipContent: tooltipContent, shortcut: shortcut })=>{
    const isFhsEnabled = (0, $1fHIr.useIsFhsEnabled)();
    const splitterRef = (0, $cozmU.useRef)(null);
    const labelId = (0, $6JrSr.useId)(); // Separate state used for the input range width to remove the UI's dependency on the "persisted" layout state value being updated
    const [rangeInputValue, setRangeInputValue] = (0, $cozmU.useState)(panelWidth); /**
                                                                       * We are using state to store the resize bounds _converted into pixel units_, so that we can update them when the window is resized.
                                                                       * Otherwise they can become out of sync with the actual viewport size, and cause a broken experience (inaccurate width percentage)
                                                                       * when the user tries to resize using the keyboard.
                                                                       */ 
    const [rangeInputBounds, setRangeInputBounds] = (0, $cozmU.useState)({
        // Using placeholder values here for the initial render. These will be calculated and updated when the range input is focused.
        min: 200,
        max: 500
    });
    const openLayerObserver = (0, $kgGsB.useOpenLayerObserver)(); /**
                                                     * This is a temporary workaround to enable the `SideNavPanelSplitter` component
                                                     * to collapse the side nav on double click, without exposing the `onDoubleClick` prop on `PanelSplitter`.
                                                     * Once `PanelSplitter` supports an `onDoubleClick` prop directly, this context can be removed.
                                                     */ 
    const onDoubleClick = (0, $cozmU.useContext)((0, $eoCwK.OnDoubleClickContext)); // Storing the initial `clientX` on `mousedown` events, to workaround a bug caused by some browser extensions
    // where the `dragstart` event incorrectly returns `0` for the `clientX` location.
    const initialClientXRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        const splitter = splitterRef.current;
        (0, $bB0i2.default)(splitter, 'Splitter ref must be set');
        return (0, $4QfFX.combine)((0, $cUdy2.blockDraggingToIFrames)({
            element: splitter
        }), /**
     * Capturing the initial `clientX` from the mousedown, before the drag starts.
     *
     * ⚠️ Note: We are not using pragmatic-drag-and-drop's `onDragStart` for this as some browser
     * extensions can cause the client location (e.g. clientX) to incorrectly return 0 during the `dragstart` event.
     *
     * We are also not using pragmatic-drag-and-drop's `onDrag` here as it is throttled, which means
     * fast mouse movements can cause the real first drag event to be missed, causing a different clientX
     * to be captured.
     *
     * I also tried only binding an event listener inside pragmatic-drag-and-drop's `onDragStart`, which seemd to work
     * but did not feel as robust, and might have timing issues as it happens slightly later.
     */ (0, $cbY7C.bind)(splitter, {
            type: 'mousedown',
            listener: (event)=>{
                initialClientXRef.current = event.clientX;
            }
        }), (0, $4Vdlk.draggable)({
            element: splitter,
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                // We will be moving the line to indicate a drag. We can disable the native drag preview
                (0, $cIWiw.disableNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage
                }); // We don't want any native drop animation for when the user does not drop on a drop target. We want the drag to finish immediately
                (0, $fGXGw.preventUnhandled).start();
            },
            getInitialData () {
                const initialWidth = (0, $j6GCu.getPixelWidth)(panel); /**
                                                    * The drag calculations require the actual computed width of the element
                                                    * For example, if the panel has loaded with a width of 2000px, but the max bound is 1000px and is visually 1000px (due to the CSS `clamp()`),
                                                    * the drag calculations should use the actual width of 1000px, not the width in state of 2000px.
                                                    */ 
                return $aa50747aa4702ef1$var$signPanelSplitterDragData({
                    panelId: panelId,
                    initialWidth: initialWidth,
                    resizingWidth: `${initialWidth}px`,
                    resizeBounds: getResizeBounds(),
                    // Only computing text direction when we need it, just as the drag is starting.
                    // Recomputing text direction on each new drag in case the text direction
                    // has changed. This is unlikely, but being safe.
                    direction: $aa50747aa4702ef1$var$getTextDirection(panel)
                });
            },
            onDragStart ({ source: source }) {
                /**
         * ⚠️ Note: We are not using the client locations (e.g. clientX) during `onDragStart`
         * because some browser extensions can cause the event properties to incorrectly return 0.
         */ (0, $bB0i2.default)((0, $aLgN8.isPanelSplitterDragData)(source.data));
                onResizeStart?.({
                    initialWidth: source.data.initialWidth
                }); // Close any open layers when the user starts resizing
                openLayerObserver?.closeLayers();
            },
            onDrag ({ location: location, source: source_0 }) {
                /**
         * ⚠️ Note: We are not using the location.initial.input client locations because some browser extensions
         * can cause the client locations (e.g. clientX) in the `dragstart` event to incorrectly return 0.
         */ (0, $bB0i2.default)((0, $aLgN8.isPanelSplitterDragData)(source_0.data));
                const { initialWidth: initialWidth_0, resizeBounds: resizeBounds, direction: direction } = source_0.data;
                (0, $bB0i2.default)(initialClientXRef.current !== null, 'initialClientX must be set'); /**
                                                                                      * How wide the element would be if there were no width constraints,
                                                                                      * based on the pointer's position.
                                                                                      */ 
                const targetWidth = (0, $6ZWGn.getWidthFromDragLocation)({
                    initialWidth: initialWidth_0,
                    location: location,
                    // The fallback of 0 won't be used due to the invariant, however we require one to satisfy the type.
                    initialClientX: initialClientXRef.current ?? 0,
                    direction: direction,
                    position: position
                });
                const resizingWidth = `clamp(${resizeBounds.min}, ${targetWidth}px, ${resizeBounds.max})`;
                panel.style.setProperty(resizingCssVar, resizingWidth);
                source_0.data.resizingWidth = resizingWidth;
            },
            onDrop ({ source: source_1 }) {
                (0, $bB0i2.default)((0, $aLgN8.isPanelSplitterDragData)(source_1.data));
                (0, $fGXGw.preventUnhandled).stop();
                const finalWidth = (0, $j6GCu.getPixelWidth)(panel);
                onCompleteResize(finalWidth);
                onResizeEnd?.({
                    initialWidth: source_1.data.initialWidth,
                    finalWidth: finalWidth
                });
                panel.style.removeProperty(resizingCssVar);
            }
        }));
    }, [
        onCompleteResize,
        onResizeStart,
        onResizeEnd,
        panel,
        resizingCssVar,
        panelWidth,
        position,
        openLayerObserver,
        panelId,
        getResizeBounds
    ]);
    const onResizeStartStableRef = (0, $jyAY3.default)(onResizeStart);
    const onResizeEndStableRef = (0, $jyAY3.default)(onResizeEnd);
    const [keyboardResizeManager] = (0, $cozmU.useState)(()=>(0, $1NH4A.createKeyboardResizeManager)({
            onResizeStart: (...args)=>{
                // Close any open layers when the user starts resizing with keyboard
                openLayerObserver?.closeLayers();
                onResizeStartStableRef.current?.(...args);
            },
            onResizeEnd: (...args_0)=>onResizeEndStableRef.current?.(...args_0)
        }));
    const handleSliderInputChange = (0, $cozmU.useCallback)((event_0)=>{
        const value = parseInt(event_0.target.value);
        setRangeInputValue(value); /**
                                * We are intentionally _not_ debouncing `onCompleteResize` as we want it to be called anytime the user changes the range input value.
                                * It is an internal-only callback - it's provided by `PanelSplitterProvider`, and used by layout slots to update their layout width state.
                                */ 
        onCompleteResize(value);
        keyboardResizeManager.onResize({
            initialWidth: panelWidth,
            finalWidth: value
        });
    }, [
        onCompleteResize,
        panelWidth,
        keyboardResizeManager
    ]);
    const resizeEventListenerCleanupFn = (0, $cozmU.useRef)(null);
    const handleSliderFocus = (0, $cozmU.useCallback)(()=>{
        /**
     * We are only updating the range input's properties when the element is focused, as a performance optimisation.
     * It isn't necessary to recalculate these values until the element is going to be used.
     */ // Clean up any left over listeners in case `focus` was triggered again without `blur`.
        resizeEventListenerCleanupFn.current?.(); // Update the range input value to match the current panel width.
        setRangeInputValue(panelWidth);
        const resizeBounds_0 = getResizeBounds(); // Update the range input bounds to ensure they are accurate (in case the viewport was previously resized)
        setRangeInputBounds({
            min: (0, $bqqhM.convertResizeBoundToPixels)(resizeBounds_0.min),
            max: (0, $bqqhM.convertResizeBoundToPixels)(resizeBounds_0.max)
        }); /**
         * _While the slider element is focused_, add a window resize event listener to update the range input bounds
         * when the window is resized. This is needed to ensure the min and max widths accurately reflect the viewport
         * size - in case they are provided in vw units.
         *
         * This listener is cleaned up when the element is blurred.
         */ 
        resizeEventListenerCleanupFn.current = (0, $cbY7C.bind)(window, {
            type: 'resize',
            listener: function updateState() {
                const resizeBounds_1 = getResizeBounds();
                setRangeInputBounds({
                    min: (0, $bqqhM.convertResizeBoundToPixels)(resizeBounds_1.min),
                    max: (0, $bqqhM.convertResizeBoundToPixels)(resizeBounds_1.max)
                });
            }
        });
    }, [
        panelWidth,
        getResizeBounds
    ]);
    const handleSliderBlur = (0, $cozmU.useCallback)(()=>{
        // Remove the resize event listener when the range input is blurred.
        resizeEventListenerCleanupFn.current?.();
    }, []);
    (0, $cozmU.useEffect)(()=>{
        return function cleanup() {
            // Cleanup the resize event listener when the component is unmounted.
            resizeEventListenerCleanupFn.current?.();
        };
    }, []);
    const ariaValueText = (0, $cozmU.useMemo)(()=>`${(0, $7uL08.getPercentageWithinPixelBounds)({
            currentWidth: rangeInputValue,
            resizeBounds: rangeInputBounds
        })}% width`, [
        rangeInputValue,
        rangeInputBounds
    ]);
    return /*#__PURE__*/ (0, $9kbTQ.createPortal)(/*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": testId ? `${testId}-container` : undefined,
        className: (0, $hekY6.default)([
            $aa50747aa4702ef1$var$containerStyles.root,
            position === 'start' && $aa50747aa4702ef1$var$containerStyles.positionStart,
            position === 'end' && $aa50747aa4702ef1$var$containerStyles.positionEnd
        ])
    }, /*#__PURE__*/ $cozmU.createElement($aa50747aa4702ef1$var$MaybeTooltip, {
        tooltipContent: tooltipContent,
        shortcut: shortcut,
        testId: testId ? `${testId}-tooltip` : undefined
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        ref: splitterRef,
        "data-testid": testId,
        onDoubleClick: onDoubleClick,
        className: (0, $hekY6.default)([
            $aa50747aa4702ef1$var$grabAreaStyles.root,
            isFhsEnabled && $aa50747aa4702ef1$var$grabAreaStyles.fullHeightSidebar
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $9GVkD.default), null, /*#__PURE__*/ $cozmU.createElement("input", {
        type: "range",
        value: rangeInputValue,
        step: 20,
        min: rangeInputBounds.min,
        max: rangeInputBounds.max,
        "aria-valuetext": ariaValueText,
        "aria-labelledby": labelId,
        onChange: handleSliderInputChange,
        onFocus: handleSliderFocus,
        onBlur: handleSliderBlur
    }), /*#__PURE__*/ $cozmU.createElement("span", {
        id: labelId
    }, label)), /*#__PURE__*/ $cozmU.createElement("span", {
        className: (0, $hekY6.default)([
            $aa50747aa4702ef1$var$lineStyles.root
        ])
    })))), portal);
};
const $aa50747aa4702ef1$export$db67e3f8d3d6da0f = ({ label: label, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, testId: testId, tooltipContent: tooltipContent })=>{
    const [panel, setPanel] = (0, $cozmU.useState)(null);
    const [portal, setPortal] = (0, $cozmU.useState)(null);
    const context = (0, $cozmU.useContext)((0, $kdCH7.PanelSplitterContext));
    (0, $bB0i2.default)(context, 'Panel splitter context not set');
    const { panelRef: panelRef, portalRef: portalRef, isEnabled: isEnabled, panelId: panelId, panelWidth: panelWidth, onCompleteResize: onCompleteResize, getResizeBounds: getResizeBounds, resizingCssVar: resizingCssVar, position: position, shortcut: shortcut } = context; /**
                * **Explanation**
                *
                * _How React Suspense works_
                *
                * When a component is suspended:
                *
                * - it is _not_ "unmounted" and effects are _not_ cleaned up
                * - refs to react managed elements are cleared
                * - react adds `display:none !important` as an inline style to hide the element
                * - state is preserved
                *
                * When a suspended component is resumed:
                * - `display:none !important` inline style is removed
                * - it will re-render (without the refs set)
                * - refs will be set
                * - `useEffect` will _not_ re-run
                *
                * [More details](https://x.com/alexandereardon/status/1944617494569992440)
                *
                * _What does this mean for the panel splitter?_
                *
                * - The panel splitter renders into content into a react managed element (eg managed by Aside)
                * - When UI is suspended the portal ref is cleared
                * - After a suspense, we will get a render with cleared refs
                * - 🔥 This is problematic if we want to portal into that ref during the render
                *
                * _Approach: initial render_
                *
                * - We cannot portal the panel splitter until after the refs are initially set
                * - Effects run after refs being set. In an effect we set the ref values (which are populated),
                *   trigger a re-render and then portal into the refs.
                *
                * _Approach: suspense_
                *
                * - We put the refs into react `state` after every render
                * - The refs in `state` will not be cleared by suspending as effects are not run, or cleaned up,
                *   when components are suspended / resumed.
                * - After the post suspense render, we can use the `portalRef` (which was captured in an effect)
                *   to continue to portal into.
                *
                * _Why not store `portalRef` in `state` in `<PanelSplitterProvider>`?_
                *
                * - The `portalRef` is set high in the tree, so a re-render will cause a
                *   large amount of components to re-render (eg the whole sidebar)
                * - After a suspense, we would need to do _another_ large re-render to propagate the new refs
                * - With our current approach, any changes to `portalRef` will cause a re-render low in the tree
                *   (just in the `<PanelSplitter>`)
                */ 
    // We want this effect to run after each render (see above)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $cozmU.useEffect)(()=>{
        // Don't need to do anything
        if (!isEnabled) return;
         // It is safe to access refs in useEffect, even with Suspense
        const panelEl = panelRef.current;
        const portalEl = portalRef.current;
        (0, $bB0i2.default)(panelEl, 'panelRef not set');
        (0, $bB0i2.default)(portalEl, 'portal element not set'); // Doing our own check, as this results in fewer re-renders than react
        // (which also does it's own checks to see if a re-render should occur)
        if (panelEl === panel && portalEl === portal) return;
         // If refs don't change, react won't cause infinite loops
        setPanel(panelEl);
        setPortal(portalEl);
    });
    if (!isEnabled) return null;
    if (!portal || !panel) return null;
    return /*#__PURE__*/ $cozmU.createElement($aa50747aa4702ef1$var$PortaledPanelSplitter, {
        label: label,
        onResizeStart: onResizeStart,
        onResizeEnd: onResizeEnd,
        testId: testId,
        panelId: panelId,
        panel: panel,
        portal: portal,
        panelWidth: panelWidth,
        onCompleteResize: onCompleteResize,
        getResizeBounds: getResizeBounds,
        resizingCssVar: resizingCssVar,
        position: position,
        tooltipContent: tooltipContent,
        shortcut: shortcut
    });
};
module.exports["PanelSplitter"] = $aa50747aa4702ef1$export$db67e3f8d3d6da0f;

});

parcelRegister("kgGsB", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3fPCt = parcelRequire("3fPCt");

const $709cc20fff743ac3$export$750f5b0d6c51617e = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useOpenLayerObserver() {
    const $ = (0, $bDgLe.c)(4);
    const context = (0, $cozmU.useContext)((0, $3fPCt.OpenLayerObserverContext));
    let t0;
    bb0: {
        if (context === null) {
            t0 = null;
            break bb0;
        }
        let t1;
        if ($[0] !== context.closeLayers || $[1] !== context.getCount || $[2] !== context.onChange) {
            t1 = {
                getCount: context.getCount,
                onChange: context.onChange,
                closeLayers: context.closeLayers
            };
            $[0] = context.closeLayers;
            $[1] = context.getCount;
            $[2] = context.onChange;
            $[3] = t1;
        } else t1 = $[3];
        t0 = t1;
    }
    const publicAPI = t0;
    return publicAPI;
} : function useOpenLayerObserver() {
    const context = (0, $cozmU.useContext)((0, $3fPCt.OpenLayerObserverContext));
    const publicAPI = (0, $cozmU.useMemo)(()=>{
        if (context === null) return null;
        return {
            getCount: context.getCount,
            onChange: context.onChange,
            closeLayers: context.closeLayers
        };
    }, [
        context
    ]);
    return publicAPI;
};
module.exports["useOpenLayerObserver"] = $709cc20fff743ac3$export$750f5b0d6c51617e;

});

parcelRegister("cUdy2", function(module, exports) {

var $4Vdlk = parcelRequire("4Vdlk");


var $4QfFX = parcelRequire("4QfFX");

/**
 * Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */ function $ccdab035e89654de$var$setStyle(el, { property: property, rule: rule, priority: priority = '' }) {
    const originalValue = el.style.getPropertyValue(property);
    const originalPriority = el.style.getPropertyPriority(property);
    el.style.setProperty(property, rule, priority);
    return function cleanup() {
        el.style.setProperty(property, originalValue, originalPriority);
    };
}
let $ccdab035e89654de$var$isActive = false;
/**
 * Start blocking dragging to iframes. Only to be called once a drag has started.
 */ function $ccdab035e89654de$var$tryStart() {
    // There can technically be multiple registrations on the same element.
    // Adding a guard to ensure that only one registration does the blocking.
    if ($ccdab035e89654de$var$isActive) return;
    $ccdab035e89654de$var$isActive = true;
    // At this stage, we are also not watching for new iframe elements being added to the page
    // (we _could_ do that as a future change)
    const iframeCleanups = Array.from(document.querySelectorAll('iframe')).map((iframe)=>$ccdab035e89654de$var$setStyle(iframe, {
            property: 'pointer-events',
            rule: 'none',
            priority: 'important'
        }));
    // Not returning the cleanup function.
    // This code will clean itself up when the interaction ends in `onDrop()`.
    // Once a drag has started we are blocking iframes until the interaction is finished.
    const cleanup = (0, $4QfFX.combine)(...iframeCleanups, // We only need this monitor for listening to the drop
    // as our monitor in `blockDraggingToIFrames()` will only
    // call this function when the drag has started
    (0, $4Vdlk.monitorForElements)({
        onDrop () {
            cleanup();
        }
    }), function release() {
        $ccdab035e89654de$var$isActive = false;
    });
}
function $ccdab035e89654de$export$6ae1d8fab001518c({ element: element }) {
    return (0, $4Vdlk.monitorForElements)({
        onGenerateDragPreview ({ source: source }) {
            // only starting if we are dragging the provided element
            if (source.element === element) $ccdab035e89654de$var$tryStart();
        }
    });
}
module.exports["blockDraggingToIFrames"] = $ccdab035e89654de$export$6ae1d8fab001518c;

});

parcelRegister("1fHIr", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $fvwa0 = parcelRequire("fvwa0");

const $306fbdba1b69a421$export$8b40a725a91166de = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const isFhsEnabled = (0, $cozmU.useContext)((0, $fvwa0.IsFhsEnabledContext));
    let t0;
    if ($[0] !== isFhsEnabled) {
        t0 = typeof isFhsEnabled === "boolean" ? isFhsEnabled : isFhsEnabled();
        $[0] = isFhsEnabled;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const isFhsEnabled = (0, $cozmU.useContext)((0, $fvwa0.IsFhsEnabledContext));
    return typeof isFhsEnabled === 'boolean' ? isFhsEnabled : isFhsEnabled();
};
module.exports["useIsFhsEnabled"] = $306fbdba1b69a421$export$8b40a725a91166de;

});

parcelRegister("fvwa0", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");

const $cc70da0c927ab5a3$export$1e91b29ada71c32a = /*#__PURE__*/ (0, $cozmU.createContext)(()=>(0, $iDrrr.fg)('navx-full-height-sidebar'));
module.exports["IsFhsEnabledContext"] = $cc70da0c927ab5a3$export$1e91b29ada71c32a;

});

parcelRegister("liCgE", function(module, exports) {
/**
 * These variables are shared across the different page layout slots.
 * This violates the [UI styling standard](https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-imported-style-values/usage).
 * We have chosen to ignore this rule to prevent duplicating them across the different slots, and to provide a high level view of them and how they relate.
 */ // These are "compressed" to discourage usage.
const $df3f68d355f73372$export$951bf5156e86d974 = '--n_sNvw';
const $df3f68d355f73372$export$594e6a30db7c057e = '--n_asDw';
const $df3f68d355f73372$export$db0c2e1d744fb281 = '--n_pnlW';
const $df3f68d355f73372$export$515a0b1baafe906c = '--n_bnrM';
const $df3f68d355f73372$export$60ef3a7b1ed42328 = '--n_tNvM';
const $df3f68d355f73372$export$a16bbd599f6269e7 = '--n_rbnW';
const $df3f68d355f73372$export$1216dacffd1e9e65 = '--n_sNvlw';
const $df3f68d355f73372$export$5db28b16b6e686bc = Symbol('SideNav PanelSplitter');
const $df3f68d355f73372$export$de580d653bac8ad9 = Symbol('Aside PanelSplitter');
const $df3f68d355f73372$export$3452dcb65711af44 = Symbol('Panel PanelSplitter');
const $df3f68d355f73372$export$2874e68531ce3163 = `calc(100vh - var(--n_bnrM, 0px) - var(--n_tNvM, 0px))`;
const $df3f68d355f73372$export$bfabd8c2c572ad29 = `calc(var(--n_bnrM, 0px) + var(--n_tNvM, 0px))`;
const $df3f68d355f73372$export$855f5a09f5c99ac = '--topNavigationHeight';
const $df3f68d355f73372$export$26354f9814213292 = '--bannerHeight';
const $df3f68d355f73372$export$6bfc931a04ec5741 = '--leftSidebarWidth';
const $df3f68d355f73372$export$58de0a46980ca7f4 = '--leftPanelWidth';
const $df3f68d355f73372$export$bbbace2ff0c7ae1b = '--rightSidebarWidth';
const $df3f68d355f73372$export$753bf7651b25db91 = '--rightPanelWidth';
const $df3f68d355f73372$export$6460bd6a2446260 = `calc(var(${$df3f68d355f73372$export$26354f9814213292}, 0px) + var(${$df3f68d355f73372$export$855f5a09f5c99ac}, 0px))`;
const $df3f68d355f73372$export$3055529fab2b4edf = `calc(var(${$df3f68d355f73372$export$58de0a46980ca7f4}, 0px) + var(${$df3f68d355f73372$export$6bfc931a04ec5741}, 0px))`;
const $df3f68d355f73372$export$166d8fd766c3eb92 = `calc(var(${$df3f68d355f73372$export$bbbace2ff0c7ae1b}, 0px) + var(${$df3f68d355f73372$export$753bf7651b25db91}, 0px))`;
const $df3f68d355f73372$export$61156ceb1a99f6a0 = {
    ribbon: 4,
    // The side nav panel splitter is layered above the top nav when FHS is enabled.
    // It has the same z-index value, but is rendered after the top nav in the DOM so is stacked above.
    sideNavPanelSplitterFHS: 4,
    topBar: 4,
    banner: 4,
    // When FHS is enabled, the side nav is layered below the top nav,
    // but above the panel
    bannerFHS: 3,
    topNavFHS: 3,
    sideNav: 2,
    panelSmallViewports: 1
};
const $df3f68d355f73372$export$876effa8b02edc2f = 'side-nav';
const $df3f68d355f73372$export$a6be839a92c90df7 = 'top-nav-start';
const $df3f68d355f73372$export$762ad20d97870b35 = 'top-nav-middle';
const $df3f68d355f73372$export$8dd71e8a7db48024 = 'top-nav-end';
module.exports["sideNavVar"] = $df3f68d355f73372$export$951bf5156e86d974;
module.exports["panelVar"] = $df3f68d355f73372$export$db0c2e1d744fb281;
module.exports["bannerMountedVar"] = $df3f68d355f73372$export$515a0b1baafe906c;
module.exports["topNavMountedVar"] = $df3f68d355f73372$export$60ef3a7b1ed42328;
module.exports["sideNavLiveWidthVar"] = $df3f68d355f73372$export$1216dacffd1e9e65;
module.exports["sideNavPanelSplitterId"] = $df3f68d355f73372$export$5db28b16b6e686bc;
module.exports["panelPanelSplitterId"] = $df3f68d355f73372$export$3452dcb65711af44;
module.exports["contentInsetBlockStart"] = $df3f68d355f73372$export$bfabd8c2c572ad29;
module.exports["UNSAFE_topNavVar"] = $df3f68d355f73372$export$855f5a09f5c99ac;
module.exports["UNSAFE_bannerVar"] = $df3f68d355f73372$export$26354f9814213292;
module.exports["UNSAFE_sideNavLayoutVar"] = $df3f68d355f73372$export$6bfc931a04ec5741;
module.exports["UNSAFE_panelLayoutVar"] = $df3f68d355f73372$export$753bf7651b25db91;
module.exports["UNSAFE_MAIN_BLOCK_START_FOR_LEGACY_PAGES_ONLY"] = $df3f68d355f73372$export$6460bd6a2446260;
module.exports["openLayerObserverSideNavNamespace"] = $df3f68d355f73372$export$876effa8b02edc2f;
module.exports["openLayerObserverTopNavStartNamespace"] = $df3f68d355f73372$export$a6be839a92c90df7;
module.exports["openLayerObserverTopNavMiddleNamespace"] = $df3f68d355f73372$export$762ad20d97870b35;
module.exports["openLayerObserverTopNavEndNamespace"] = $df3f68d355f73372$export$8dd71e8a7db48024;

});

parcelRegister("bqqhM", function(module, exports) {
function $d49f7917cd31356f$export$3d412b3011b66f82(resizeBound) {
    if (resizeBound.endsWith('vw')) {
        // Max width was provided in `vw` units, so is relative to the viewport width.
        // e.g. 50vw = 50% of the viewport width.
        // `parseInt` will remove the `vw` suffix.
        const maxWidthFraction = parseInt(resizeBound) / 100;
        return Math.floor(window.innerWidth * maxWidthFraction);
    }
    // Max width was provided in `px` units, so we can parse it directly.
    // `parseInt` will remove the `px` suffix.
    return Math.floor(parseInt(resizeBound));
}
module.exports["convertResizeBoundToPixels"] = $d49f7917cd31356f$export$3d412b3011b66f82;

});

parcelRegister("7uL08", function(module, exports) {
function $eecdceaa8eea5c83$export$b5423678cdf09f5({ currentWidth: currentWidth, resizeBounds: resizeBounds }) {
    const resizeRange = resizeBounds.max - resizeBounds.min;
    const widthAsPercentage = (currentWidth - resizeBounds.min) / resizeRange * 100;
    if (widthAsPercentage < 0) return 0;
    if (widthAsPercentage > 100) return 100;
    return Math.floor(widthAsPercentage);
}
module.exports["getPercentageWithinPixelBounds"] = $eecdceaa8eea5c83$export$b5423678cdf09f5;

});

parcelRegister("j6GCu", function(module, exports) {
/**
 * Returns the computed width of an element in pixels.
 */ const $90570af16555ddca$export$d942790ad00c41f9 = (element)=>{
    // Always returns an integer. Returns 0 if element is hidden / removed.
    return element.offsetWidth;
};
module.exports["getPixelWidth"] = $90570af16555ddca$export$d942790ad00c41f9;

});

parcelRegister("6ZWGn", function(module, exports) {
const $eca965d9d38b7fed$export$e360234971cb95b8 = ({ initialWidth: initialWidth, location: location, initialClientX: initialClientX, direction: direction, position: position })=>{
    const diffX = location.current.input.clientX - initialClientX;
    // Resize line is positioned at the inline-end (right) of the element.
    // If the direction is left-to-right, the width will increase when the mouse is moved to the right, and vice versa.
    if (position === 'end') return direction === 'ltr' ? initialWidth + diffX : initialWidth - diffX;
    // Resize line is positioned at the inline-start (left) of the element.
    // If the direction is left-to-right, the width will decrease when the mouse is moved to the right, and vice versa.
    return direction === 'ltr' ? initialWidth - diffX : initialWidth + diffX;
};
module.exports["getWidthFromDragLocation"] = $eca965d9d38b7fed$export$e360234971cb95b8;

});

parcelRegister("aLgN8", function(module, exports) {

var $eMMLI = parcelRequire("eMMLI");

function $761da17727e72b97$export$e239b3966b677000(data) {
    return data[0, $eMMLI.panelSplitterDragDataSymbol] === true;
}
module.exports["isPanelSplitterDragData"] = $761da17727e72b97$export$e239b3966b677000;

});

parcelRegister("eMMLI", function(module, exports) {
const $f541948e785e50cb$export$64f49ceb7f6e9a23 = Symbol('panel-splitter-drag-data');
module.exports["panelSplitterDragDataSymbol"] = $f541948e785e50cb$export$64f49ceb7f6e9a23;

});

parcelRegister("1NH4A", function(module, exports) {
/**
 * The debounce time for the PanelSplitter resize callback functions.
 *
 * - For `onResizeStart`, it will call the callback immediately, but not
 * again until the user stops resizing and this wait time has passed.
 * - For `onResizeEnd`, it will call the callback only after this time has
 * passed since the last resize event.
 */ const $701d71138fd3edb2$var$resizeCallbackDebounceTimeMs = 500;
function $701d71138fd3edb2$export$f7d3d5dae65f74aa({ onResizeStart: onResizeStart, onResizeEnd: onResizeEnd }) {
    let resizingState = {
        type: 'idle'
    };
    /**
   * Starts a timer to reset the state to idle and call `onResizeEnd` after a wait time.
   */ function startResizeEndTimer({ initialWidth: initialWidth, finalWidth: finalWidth }) {
        const markResizeAsEndedTimeout = setTimeout(()=>{
            onResizeEnd({
                initialWidth: initialWidth,
                finalWidth: finalWidth
            });
            resizingState = {
                type: 'idle'
            };
        }, $701d71138fd3edb2$var$resizeCallbackDebounceTimeMs);
        resizingState = {
            type: 'resizing',
            initialWidth: initialWidth,
            abort () {
                clearTimeout(markResizeAsEndedTimeout);
            }
        };
    }
    function onResize({ initialWidth: initialWidth, finalWidth: finalWidth }) {
        if (resizingState.type === 'idle') {
            // If the state was idle, this counts as a resize start event.
            onResizeStart({
                initialWidth: initialWidth
            });
            startResizeEndTimer({
                initialWidth: initialWidth,
                finalWidth: finalWidth
            });
            return;
        }
        if (resizingState.type === 'resizing') {
            // If the state was already resizing, clear the existing timeout and start a new one.
            resizingState.abort();
            startResizeEndTimer({
                initialWidth: resizingState.initialWidth,
                finalWidth: finalWidth
            });
            return;
        }
    }
    return {
        onResize: onResize
    };
}
module.exports["createKeyboardResizeManager"] = $701d71138fd3edb2$export$f7d3d5dae65f74aa;

});

parcelRegister("eoCwK", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $81891a3d68477451$export$e253efba824eceb = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
module.exports["OnDoubleClickContext"] = $81891a3d68477451$export$e253efba824eceb;

});

parcelRegister("kdCH7", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $eba789b1db8bb9f2$export$7a4054f2c546f2cd = /*#__PURE__*/ (0, $cozmU.createContext)(null);
module.exports["PanelSplitterContext"] = $eba789b1db8bb9f2$export$7a4054f2c546f2cd;

});

parcelRegister("iynkA", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kdCH7 = parcelRequire("kdCH7");

const $53b5162ceac70888$export$f662bfb764348932 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(19);
    const { panelId: panelId, panelWidth: panelWidth, onCompleteResize: onCompleteResize, getResizeBounds: getResizeBounds, resizingCssVar: resizingCssVar, panelRef: panelRef, portalRef: providedPortalRef, position: t1, isEnabled: t2, shortcut: shortcut, children: children } = t0;
    const position = t1 === undefined ? "end" : t1;
    const isEnabled = t2 === undefined ? true : t2;
    const portalRef = (0, $cozmU.useRef)(null);
    const t3 = typeof providedPortalRef !== "undefined" ? providedPortalRef : portalRef;
    let t4;
    if ($[0] !== getResizeBounds || $[1] !== isEnabled || $[2] !== onCompleteResize || $[3] !== panelId || $[4] !== panelRef || $[5] !== panelWidth || $[6] !== position || $[7] !== resizingCssVar || $[8] !== shortcut || $[9] !== t3) {
        t4 = {
            panelId: panelId,
            panelWidth: panelWidth,
            onCompleteResize: onCompleteResize,
            getResizeBounds: getResizeBounds,
            resizingCssVar: resizingCssVar,
            position: position,
            panelRef: panelRef,
            isEnabled: isEnabled,
            portalRef: t3,
            shortcut: shortcut
        };
        $[0] = getResizeBounds;
        $[1] = isEnabled;
        $[2] = onCompleteResize;
        $[3] = panelId;
        $[4] = panelRef;
        $[5] = panelWidth;
        $[6] = position;
        $[7] = resizingCssVar;
        $[8] = shortcut;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    const context = t4;
    let t5;
    if ($[11] !== children || $[12] !== context) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kdCH7.PanelSplitterContext).Provider, {
            value: context
        }, children);
        $[11] = children;
        $[12] = context;
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] !== providedPortalRef) {
        t6 = typeof providedPortalRef !== "undefined" ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ref: portalRef
        });
        $[14] = providedPortalRef;
        $[15] = t6;
    } else t6 = $[15];
    let t7;
    if ($[16] !== t5 || $[17] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, t5, t6);
        $[16] = t5;
        $[17] = t6;
        $[18] = t7;
    } else t7 = $[18];
    return t7;
} : ({ panelId: panelId, panelWidth: panelWidth, onCompleteResize: onCompleteResize, getResizeBounds: getResizeBounds, resizingCssVar: resizingCssVar, panelRef: panelRef, portalRef: providedPortalRef, position: position = 'end', isEnabled: isEnabled = true, shortcut: shortcut, children: children })=>{
    const portalRef = (0, $cozmU.useRef)(null);
    const context = (0, $cozmU.useMemo)(()=>({
            panelId: panelId,
            panelWidth: panelWidth,
            onCompleteResize: onCompleteResize,
            getResizeBounds: getResizeBounds,
            resizingCssVar: resizingCssVar,
            position: position,
            panelRef: panelRef,
            isEnabled: isEnabled,
            portalRef: typeof providedPortalRef !== 'undefined' ? providedPortalRef : portalRef,
            shortcut: shortcut
        }), [
        panelId,
        panelWidth,
        onCompleteResize,
        getResizeBounds,
        resizingCssVar,
        position,
        panelRef,
        isEnabled,
        providedPortalRef,
        shortcut
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kdCH7.PanelSplitterContext).Provider, {
        value: context
    }, children), typeof providedPortalRef !== 'undefined' ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: portalRef
    }));
};
module.exports["PanelSplitterProvider"] = $53b5162ceac70888$export$f662bfb764348932;

});

parcelRegister("eCqXP", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $9kbTQ = parcelRequire("9kbTQ");


var $9DHhW = parcelRequire("9DHhW");


var $lmzCg = parcelRequire("lmzCg");


var $jyAY3 = parcelRequire("jyAY3");


var $1IrNk = parcelRequire("1IrNk");


var $kgGsB = parcelRequire("kgGsB");


var $iDrrr = parcelRequire("iDrrr");


var $4Vdlk = parcelRequire("4Vdlk");


var $gnKXs = parcelRequire("gnKXs");


var $eaAhc = parcelRequire("eaAhc");


var $a5Bb1 = parcelRequire("a5Bb1");


var $1fHIr = parcelRequire("1fHIr");


var $liCgE = parcelRequire("liCgE");


var $4aMCy = parcelRequire("4aMCy");


var $b24kF = parcelRequire("b24kF");


var $iynkA = parcelRequire("iynkA");


var $eyPWA = parcelRequire("eyPWA");


var $IRNbu = parcelRequire("IRNbu");


var $6iHsT = parcelRequire("6iHsT");


var $4xyOi = parcelRequire("4xyOi");


var $2udoJ = parcelRequire("2udoJ");


var $2E6Hq = parcelRequire("2E6Hq");


var $8CGNp = parcelRequire("8CGNp");


var $5rNCB = parcelRequire("5rNCB");


var $aFvBm = parcelRequire("aFvBm");


var $d8d8E = parcelRequire("d8d8E");


var $1gX7M = parcelRequire("1gX7M");


var $g9jMx = parcelRequire("g9jMx");


var $gjVTm = parcelRequire("gjVTm");


var $7PUR3 = parcelRequire("7PUR3");


var $6NDDH = parcelRequire("6NDDH");

const $69afecb6c46cd616$var$panelSplitterResizingVar = '--n_snvRsz'; // Used to share the side nav width with the panel splitter, which is rendered outside the side nav element
// but positioned to stay at its right edge.
const $69afecb6c46cd616$var$sideNavClampedWidthVar = '--n_snvW';
const $69afecb6c46cd616$var$widthResizeBounds = {
    min: '240px',
    max: '50vw'
};
function $69afecb6c46cd616$var$getResizeBounds() {
    return $69afecb6c46cd616$var$widthResizeBounds;
} /**
   * We are using JS to detect Firefox and disable animations, instead of using CSS, as Compiled currently does not merge duplicate
   * CSS at-rules when at-rules are nested: https://github.com/atlassian-labs/compiled/blob/e04a325915e1d13010205089e4915de0e53bc2d4/packages/css/src/plugins/merge-duplicate-at-rules.ts#L5
   * Avoiding nesting the `@supports` at-rule inside of `@media` means Compiled can remove duplicate styles from the generated CSS.
   */ 
const $69afecb6c46cd616$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
const $69afecb6c46cd616$var$panelSplitterPortalTargetStyles = {
    root: "_1mT5xdy1CL _42Yu6B8OLE _1ZB6UydnbC _1VJPca4Hw8 _0jFU0VlOMI _2MwU8rfsLy _1EkTBE4L7p"
};
const $69afecb6c46cd616$var$styles = {
    root: "_2YmqfPYbGa _1VfddaYbGa _0KLXruoI2d _2OUyjtGk8v _24h04i2Njc _0jFU0VlOMI _2I62gzgiHs _1mT5xdHE3j _39xV02uZus _42Yu6BiZR3 _2EWYUbX3P0 _1KvygPUzyj _1EUs3cOeNX _0hAebtlfZc _1RYJRxYbGa _0xO92q39pk",
    flyoutOpen: "_1KvygPOQJL _1EUs3cYbGa _0hAebtoI2d _1RYJRxGk8v _2AFbI1Rodp _4kVtJl2HTN _1UvFJ1ThaV _1E7uFmIt9z",
    flyoutAnimateClosed: "_3iDTPbYbGa _1KvygPOQJL _2AFbI1Rodp _4kVtJl2HTN _1UvFJ1ThaV _4pNSLEIt9z",
    animationRTLSupport: "_2LGtmL7dHp _0pbPskvQQr",
    flyoutBaseStylesFullHeightSidebar: "_1KvygPOQJL _1EUs3cYbGa _0hAebtoI2d _1RYJRxGk8v _2SsmzmRodp _2QPceGThaV",
    flyoutOpenFullHeightSidebar: "_19NLAJ2HTN _03zLI5AYH4 _1QQNNIJF1Y",
    flyoutAnimateClosedFullHeightSidebar: "_0THHewYbGa _19NLAJ2HTN _03zLI5ROYS _19veLJJF1Y",
    flexContainer: "_0jFU0VN91d _3iDTPbQ4SZ _0aFT5vbt8w _37wbyuI7V3",
    hiddenMobileAndDesktop: "_3iDTPbYbGa",
    hiddenMobileOnly: "_3iDTPbYbGa _0THHewyL8i",
    hiddenDesktopOnly: "_0THHewYbGa",
    animationBaseStyles: "_2qDx9mRodp _4tikTSThaV _03Q0ee2HTN",
    expandAnimationMobile: "_4BklsuAYH4 _3WRiEcJF1Y",
    collapseAnimationMobile: "_3NcSKiOQJL _4BklsuROYS _0G6dy0JF1Y",
    expandAnimationDesktop: "_4fJQ5SUzyj _03zLI5AYH4 _1QQNNIJF1Y",
    collapseAnimationDesktop: "_4fJQ5SOQJL _03zLI5ROYS _19veLJJF1Y"
}; /**
    * Styles for the side nav enter/exit animations when `platform-dst-motion-uplift-sidenav` is enabled.
    *
    * These use the `motion.sidenav.*` tokens (keyframe animations) instead of the `transform` transitions
    * with `@starting-style` used by `styles`.
    *
    * ⚠️ The `transition-duration` values below need to stay in sync with the duration baked into the tokens
    * (`motion.sidenav.enter.*` is 250ms, `motion.sidenav.exit.*` is 200ms). The `display` property is
    * transitioned (with `allow-discrete`) so the element stays rendered for the length of the exit animation —
    * if the transition is shorter than the animation, `display: none` applies early and the exit animation
    * never runs.
    */ 
const $69afecb6c46cd616$var$motionUpliftStyles = {
    animationRTLSupport: "_0PlsTg2NCt _41VWnOVFMz _3G2eGnoK2N _0bboGQuqca",
    animationBaseStyles: "_2qDx9m4Gny _4tikTSThaV _03Q0eeLrT7",
    expandAnimationMobile: "_1jZhRJWRfq",
    collapseAnimationMobile: "_3NcSKiOQJL _1jZhRJTRd8",
    flyoutOpen: "_1KvygPOQJL _1EUs3cYbGa _0hAebtoI2d _1RYJRxGk8v _0k9R9aWRfq _4kVtJlqvoi _1UvFJ1ThaV",
    flyoutAnimateClosed: "_3iDTPbYbGa _1KvygPOQJL _0k9R9aTRd8 _4kVtJlLrT7 _1UvFJ1ThaV",
    flyoutOpenFullHeightSidebar: "_1wp4FmWRfq _19NLAJqvoi",
    flyoutAnimateClosedFullHeightSidebar: "_0THHewYbGa _1wp4FmTRd8 _19NLAJLrT7",
    expandAnimationDesktop: "_4fJQ5SUzyj _1wp4FmWRfq _4Bj9bNOQJL _2SsmzmIE5y _19NLAJxlqh _4y5EJLRLuw",
    collapseAnimationDesktop: "_4fJQ5SOQJL _1wp4FmTRd8"
};
const $69afecb6c46cd616$var$fallbackDefaultWidth = 320;
const $69afecb6c46cd616$export$c735dc1c21910e21 = 500; /**
                                        * We need an additional component layer so we can wrap the side nav in a `OpenLayerObserver` and have access to the
                                        * context value.
                                        */ 
function $69afecb6c46cd616$var$SideNavInternal({ children: children, defaultCollapsed: defaultCollapsed, defaultWidth: defaultWidthProp = $69afecb6c46cd616$var$fallbackDefaultWidth, testId: testId, label: label = 'Sidebar', skipLinkLabel: skipLinkLabel = label, onExpand: onExpand, onCollapse: onCollapse, onPeekStart: onPeekStart, onPeekEnd: onPeekEnd, id: providedId, canToggleWithShortcut: canToggleWithShortcut }) {
    const isFhsEnabled = (0, $1fHIr.useIsFhsEnabled)();
    const id = (0, $eyPWA.useLayoutId)({
        providedId: providedId
    });
    const expandAndFocusSideNav = (0, $aFvBm.useExpandSideNav)({
        trigger: 'skip-link'
    }); /**
       * Called after clicking on the side nav skip link, and ensures the side nav is expanded so that it is focusable.
       *
       * We need to update the DOM synchronously because `.focus()` is called synchronously after this state update.
       *
       * Only used when `platform_dst_nav4_skip_link_a11y_1` is OFF; can be removed on gate cleanup.
       */ 
    const synchronouslyExpandSideNav = (0, $cozmU.useCallback)(()=>{
        (0, $9kbTQ.flushSync)(()=>{
            /**
       * Calling this unconditionally and relying on it to avoid no-op renders.
       *
       * We _could_ call it conditionally, but we'd be duplicating the screen size checks `expandAndFocusSideNav` makes.
       */ expandAndFocusSideNav();
        });
    }, [
        expandAndFocusSideNav
    ]);
    (0, $eaAhc.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        /**
     * `navigate` is the gate-on contract: it owns expanding the side nav AND moving
     * focus to the first nav item, atomically (via `useExpandSideNav`'s `flushSync`).
     *
     * `onBeforeNavigate` is the legacy contract used only when the gate is OFF.
     * On gate cleanup, drop `onBeforeNavigate` and `synchronouslyExpandSideNav` here.
     */ navigate: (0, $iDrrr.fg)('platform_dst_nav4_skip_link_a11y_1') ? expandAndFocusSideNav : undefined,
        onBeforeNavigate: (0, $iDrrr.fg)('platform_dst_nav4_skip_link_a11y_1') ? undefined : synchronouslyExpandSideNav
    });
    const sideNavState = (0, $cozmU.useContext)((0, $5rNCB.SideNavVisibilityState));
    const setSideNavState = (0, $cozmU.useContext)((0, $2udoJ.SetSideNavVisibilityState));
    const { isExpandedOnDesktop: isExpandedOnDesktop, isExpandedOnMobile: isExpandedOnMobile } = (0, $gjVTm.useSideNavVisibility)({
        defaultCollapsed: defaultCollapsed
    }); // We are placing `defaultCollapsed` into a state container so we can have a stable reference to the initial value.
    // This is so we can use it in an effect _that only runs once_, after the initial render on the client,
    // to sync the side nav context (provided in `<Root>`) with the `defaultCollapsed` prop provided to `<SideNav>`.
    const [initialDefaultCollapsed] = (0, $cozmU.useState)(defaultCollapsed);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [initialIsExpandedOnDesktop] = (0, $cozmU.useState)(isExpandedOnDesktop); /**
                                                                       * Captures the initial collapsed/expanded state of the side nav.
                                                                       *
                                                                       * Only firing on desktop because the nav is never open by default on mobile.
                                                                       */ 
    (0, $cozmU.useEffect)(()=>{
        if (initialIsExpandedOnDesktop) {
            const isDesktop = window.matchMedia('(min-width: 64rem)').matches;
            if (isDesktop) {
                const navigationAnalyticsEvent = createAnalyticsEvent({
                    source: 'topNav',
                    actionSubject: 'sideNav',
                    action: 'viewedOnLoad',
                    actionSubjectId: 'sideNavMenu',
                    attributes: {
                        screen: 'desktop'
                    }
                });
                navigationAnalyticsEvent.fire('navigation');
            }
        }
    }, [
        createAnalyticsEvent,
        initialIsExpandedOnDesktop
    ]);
    const defaultWidth = (0, $6iHsT.useSafeDefaultWidth)({
        defaultWidthProp: defaultWidthProp,
        fallbackDefaultWidth: $69afecb6c46cd616$var$fallbackDefaultWidth,
        slotName: 'SideNav'
    });
    const [width, setWidth] = (0, $cozmU.useState)(defaultWidth);
    const clampedWidth = `clamp(${$69afecb6c46cd616$var$widthResizeBounds.min}, ${width}px, ${$69afecb6c46cd616$var$widthResizeBounds.max})`;
    const dangerouslyHoistSlotSizes = (0, $cozmU.useContext)((0, $b24kF.DangerouslyHoistSlotSizes));
    const navRef = (0, $cozmU.useRef)(null);
    const panelSplitterPortalTargetRef = (0, $cozmU.useRef)(null); /**
                                                                             * Used to share the side nav element with the `Panel`,
                                                                             * which observes the side nav to determine its maximum width.
                                                                             */ 
    const sharedRef = (0, $1gX7M.useSideNavRef)();
    const mergedRef = (0, $lmzCg.default)([
        navRef,
        sharedRef
    ]);
    const toggleButtonElement = (0, $cozmU.useContext)((0, $2E6Hq.SideNavToggleButtonElement));
    const topNavStartElement = (0, $cozmU.useContext)((0, $a5Bb1.TopNavStartElement));
    const devTimeOnlyAttributes = {};
    const openLayerObserver = (0, $kgGsB.useOpenLayerObserver)();
    const flyoutStateRef = (0, $cozmU.useRef)({
        type: 'not-active'
    });
    const isFlyoutVisible = sideNavState?.flyout === 'open';
    const isExpandedOnDesktopRef = (0, $jyAY3.default)(isExpandedOnDesktop);
    const hasPeekStartedRef = (0, $cozmU.useRef)(false);
    const onPeekStartRef = (0, $jyAY3.default)(onPeekStart);
    const onPeekEndRef = (0, $jyAY3.default)(onPeekEnd);
    const onPeekStartTimeoutIdRef = (0, $cozmU.useRef)(undefined);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            clearTimeout(onPeekStartTimeoutIdRef.current);
        };
    }, []);
    const updateFlyoutState = (0, $cozmU.useMemo)(()=>{
        function tryAbortPendingClose() {
            if (flyoutStateRef.current.type === 'waiting-for-close') flyoutStateRef.current.abort();
        }
        function open() {
            // Prevent the flyout from being opened if there are any open layers in the top nav start
            if (openLayerObserver && openLayerObserver.getCount({
                namespace: (0, $liCgE.openLayerObserverTopNavStartNamespace),
                type: 'popup'
            }) > 0) return;
            const prevFlyoutState = flyoutStateRef.current;
            tryAbortPendingClose();
            flyoutStateRef.current = {
                type: 'open'
            };
            setSideNavState((currentState)=>{
                if (currentState?.desktop === 'collapsed' && currentState?.flyout !== 'open') return {
                    ...currentState,
                    flyout: 'open'
                };
                return currentState;
            }); // Avoid redundant calls to `onPeekStart()`
            if (prevFlyoutState.type === 'not-active') {
                clearTimeout(onPeekStartTimeoutIdRef.current);
                onPeekStartTimeoutIdRef.current = setTimeout(()=>{
                    // If the flyout isn't still open after ~500ms then we won't count the peek
                    // As we want to track user intention rather than all hovers
                    if (isExpandedOnDesktopRef.current || flyoutStateRef.current.type !== 'open') return;
                    hasPeekStartedRef.current = true;
                    onPeekStartRef.current?.();
                }, $69afecb6c46cd616$export$c735dc1c21910e21);
            }
        }
        function close() {
            const prevFlyoutState_0 = flyoutStateRef.current;
            tryAbortPendingClose();
            flyoutStateRef.current = {
                type: 'not-active'
            };
            setSideNavState((currentState_0)=>{
                if (currentState_0?.desktop === 'collapsed' && currentState_0?.flyout === 'open') return {
                    ...currentState_0,
                    flyout: 'triggered-animate-close'
                };
                return currentState_0;
            }); // Avoid redundant calls to `onPeekEnd()`
            if (prevFlyoutState_0.type !== 'not-active' && hasPeekStartedRef.current) {
                hasPeekStartedRef.current = false;
                onPeekEndRef.current?.({
                    trigger: isExpandedOnDesktopRef.current ? 'side-nav-expand' : 'mouse-leave'
                });
            }
        }
        return function onAction(action) {
            if (action === 'drag-from-flyout-started') {
                open();
                flyoutStateRef.current = {
                    type: 'is-dragging-from-flyout'
                };
                return;
            }
            if (action === 'drag-from-flyout-finished') {
                open();
                return;
            } // ignoring all actions until the drag is finished
            if (flyoutStateRef.current.type === 'is-dragging-from-flyout') return;
            if (action === 'open') {
                open();
                return;
            }
            if (action === 'waiting-for-close') {
                if (flyoutStateRef.current.type === 'waiting-for-close') return;
                 // A timeout is used to close the flyout after a delay when the user mouses out of the flyout area, and to allow
                // us to cancel the close if the user mouses back in.
                const timeout = setTimeout(()=>{
                    updateFlyoutState('ready-to-close');
                }, (0, $4xyOi.sideNavFlyoutCloseDelayMs));
                flyoutStateRef.current = {
                    type: 'waiting-for-close',
                    abort () {
                        clearTimeout(timeout);
                    }
                };
                return;
            }
            if (action === 'ready-to-close') {
                // If there are no open layers, we can close the flyout.
                if (openLayerObserver?.getCount({
                    namespace: (0, $liCgE.openLayerObserverSideNavNamespace)
                }) === 0) {
                    close();
                    return;
                }
                flyoutStateRef.current = {
                    type: 'ready-to-close'
                };
                return;
            }
            if (action === 'force-close') {
                close();
                return;
            }
        };
    }, [
        isExpandedOnDesktopRef,
        onPeekEndRef,
        onPeekStartRef,
        openLayerObserver,
        setSideNavState
    ]);
    const toggleVisibilityByScreenResize = (0, $6NDDH.useToggleSideNav)({
        trigger: 'screen-resize'
    });
    const toggleVisibilityByClickOutsideOnMobile = (0, $6NDDH.useToggleSideNav)({
        trigger: 'click-outside-on-mobile'
    }); // Using `useLayoutEffect` so that there's no visual shift in non-SSR environments when using legacy API
    // For SSR the new API is still necessary
    (0, $cozmU.useLayoutEffect)(()=>{
        if (sideNavState !== null) // Only need to do an initial sync if it hasn't been initialized from Root
        return;
         // Sync the visibility in context (provided in `<Root>`) with the local `defaultCollapsed` prop provided to `SideNav`
        // after SSR hydration. This should only run once, after the initial render on the client.
        (0, $cozmU.startTransition)(()=>{
            setSideNavState({
                desktop: initialDefaultCollapsed ? 'collapsed' : 'expanded',
                mobile: 'collapsed',
                flyout: 'closed',
                lastTrigger: null
            });
        });
    }, [
        initialDefaultCollapsed,
        setSideNavState,
        sideNavState
    ]);
    const handleExpand = (0, $cozmU.useCallback)(({ screen: screen, trigger: trigger })=>{
        onExpand?.({
            screen: screen,
            trigger: trigger
        });
        const navigationAnalyticsEvent_0 = createAnalyticsEvent({
            source: 'topNav',
            actionSubject: 'sideNav',
            action: 'expanded',
            actionSubjectId: 'sideNavMenu',
            attributes: {
                trigger: trigger
            }
        });
        navigationAnalyticsEvent_0.fire('navigation'); // When the side nav gets expanded, we close the flyout to reset it.
        // This prevents the flyout from staying open and ensures we are respecting the user's intent to expand.
        updateFlyoutState('force-close');
    }, [
        onExpand,
        updateFlyoutState,
        createAnalyticsEvent
    ]);
    const handleCollapse = (0, $cozmU.useCallback)(({ screen: screen_0, trigger: trigger_0 })=>{
        onCollapse?.({
            screen: screen_0,
            trigger: trigger_0
        });
        const navigationAnalyticsEvent_1 = createAnalyticsEvent({
            source: 'topNav',
            actionSubject: 'sideNav',
            action: 'collapsed',
            actionSubjectId: 'sideNavMenu',
            attributes: {
                trigger: trigger_0
            }
        });
        navigationAnalyticsEvent_1.fire('navigation'); // When the side nav gets collapsed, we close the flyout to reset it.
        // This prevents the flyout from staying open and ensures we are respecting the user's intent to collapse.
        updateFlyoutState('force-close');
    }, [
        onCollapse,
        updateFlyoutState,
        createAnalyticsEvent
    ]);
    (0, $7PUR3.useSideNavVisibilityCallbacks)({
        onExpand: handleExpand,
        onCollapse: handleCollapse,
        isExpandedOnDesktop: isExpandedOnDesktop,
        isExpandedOnMobile: isExpandedOnMobile,
        lastTrigger: sideNavState?.lastTrigger ?? null
    });
    (0, $cozmU.useEffect)(()=>{
        const mediaQueryList = window.matchMedia('(min-width: 64rem)');
        return (0, $cbY7C.bind)(mediaQueryList, {
            type: 'change',
            listener () {
                if (mediaQueryList.matches) // We're transitioning from tablet to desktop viewport size.
                // We forcibly show the side nav if it was shown on mobile.
                {
                    if (isExpandedOnMobile && !isExpandedOnDesktop) toggleVisibilityByScreenResize();
                }
            }
        });
    }, [
        toggleVisibilityByScreenResize,
        isExpandedOnDesktop,
        isExpandedOnMobile
    ]); /**
                                                                                  * Close the mobile side nav if there is a click outside.
                                                                                  *
                                                                                  * Binding/unbinding on changes to `isExpandedOnMobile` instead of window size changes for simplicity.
                                                                                  * If we listened to window size changes we'd need nested `bind()` calls.
                                                                                  */ 
    (0, $cozmU.useEffect)(()=>{
        if (!isExpandedOnMobile) return;
         /**
       * The expected URL fragment used by the side nav skip link.
       */ 
        const skipLinkUrlFragment = `#${id}`;
        return (0, $cbY7C.bind)(window, {
            type: 'click',
            listener (event) {
                if (window.matchMedia('(min-width: 64rem)').matches) // Clicks on desktop should do nothing
                return;
                const sideNav = navRef.current;
                if (!sideNav || !(event.target instanceof Node)) // Ignore if our element references are invalid
                return;
                if (!event.target.isConnected) /**
           * If the element that was clicked is no longer in the document, we should not collapse the side nav.
           * This can happen when the user clicks on a dropdown menu item (such as one used in a `...` More menu),
           * as the dropdown menu will close after being clicked. By the time this event listener runs, the clicked
           * element will no longer be in the document, so the check below for `sideNav.contains(event.target)` will fail.
           */ return;
                if (sideNav.contains(event.target)) // Clicks inside the side nav should not close it
                return;
                if (toggleButtonElement?.contains(event.target)) // Clicks on the toggle button will already toggle the side nav,
                // so we need to ignore it or we end up doing a double toggle
                return;
                if (event.target instanceof HTMLAnchorElement && /**
         * Intentionally using `.getAttribute()` for simplicity to match exactly what we expect
         * for skip links.
         *
         * Alternatives considered:
         *
         * - Using `.href` returns a full URL, which would then require extra parsing.
         * - Using `.hash` could incorrectly capture `<a href="/another-page#skip-link-id>` so we'd need extra checks.
         *
         * This approach has an edge case of `<a href="/same-page#skip-link-id>` not being captured,
         * but we are okay with that trade-off.
         */ event.target.getAttribute('href') === skipLinkUrlFragment) // This was a click on a link to the side nav, so we shouldn't try to collapse the SideNav.
                // It was most likely the skip link, although anyone can render a link with the ID.
                // In either case keeping the SideNav expanded makes sense.
                return;
                toggleVisibilityByClickOutsideOnMobile();
            }
        });
    }, [
        id,
        isExpandedOnMobile,
        toggleButtonElement,
        toggleVisibilityByClickOutsideOnMobile
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!toggleButtonElement) return;
        return (0, $cbY7C.bind)(toggleButtonElement, {
            type: 'mouseenter',
            listener () {
                // Only flyout the side nav if the user hovered while the side nav was collapsed
                if (isExpandedOnDesktop) return;
                 // Only flyout the side nav on desktop viewports
                const { matches: matches } = window.matchMedia('(min-width: 64rem)');
                if (matches) updateFlyoutState('open');
            }
        });
    }, [
        updateFlyoutState,
        toggleButtonElement,
        isExpandedOnDesktop
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!toggleButtonElement) return;
        return (0, $cbY7C.bind)(toggleButtonElement, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        isFlyoutVisible,
        toggleButtonElement,
        updateFlyoutState
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!navRef.current) return;
        return (0, $cbY7C.bind)(navRef.current, {
            type: 'mouseenter',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (isExpandedOnDesktop || !isFlyoutVisible) return;
                 // The user mouses has moused back over the side nav
                updateFlyoutState('open');
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState,
        isExpandedOnDesktop
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!navRef.current) return;
        return (0, $cbY7C.bind)(navRef.current, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $cozmU.useEffect)(()=>{
        const nav = navRef.current;
        if (!nav) return;
        if (!isFlyoutVisible) return;
         // Using a monitor rather than a drop target. Rationale:
        // - We are not creating a drop target for the users to drop on,
        //   we are just interested in listening to events within an element
        // - We do not want to impact `location.{*}.dropTargets` in events
        return (0, $4Vdlk.monitorForElements)({
            canMonitor ({ source: source }) {
                return nav.contains(source.element);
            },
            onGenerateDragPreview () {
                updateFlyoutState('drag-from-flyout-started');
            },
            onDrop ({ location: location }) {
                // Always marking the drag and done
                updateFlyoutState('drag-from-flyout-finished'); // If the user dropped outside of the flyout, we will close the flyout
                const underUsersPointer = document.elementFromPoint(location.current.input.clientX, location.current.input.clientY);
                if (!nav.contains(underUsersPointer)) updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!topNavStartElement || !toggleButtonElement) return;
        return (0, $cbY7C.bind)(topNavStartElement, {
            type: 'mouseover',
            listener (event_0) {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (isExpandedOnDesktop || !isFlyoutVisible) return;
                if (event_0.target === topNavStartElement) {
                    // The mouse is directly over the TopNavStart element, so cancel any pending flyout closes.
                    updateFlyoutState('open');
                    return;
                }
                if (event_0.target instanceof Element && toggleButtonElement.contains(event_0.target)) // The mouse is over the toggle button or any of its children, so we don't want to close the flyout.
                // We also don't need to cancel any pending closes, as we have separate event listeners for the toggle button mouse events.
                return;
                 // The user has moused over a child element of the TopNavStart element that isn't the toggle button, e.g. the app switcher or nav logo,
                // so we should close the flyout (with a delay).
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        topNavStartElement,
        isFlyoutVisible,
        toggleButtonElement,
        isExpandedOnDesktop,
        updateFlyoutState
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!topNavStartElement) return;
        return (0, $cbY7C.bind)(topNavStartElement, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                 // The mouse has left the TopNavStart element, so we should close the flyout with a delay.
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        topNavStartElement,
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $cozmU.useEffect)(()=>{
        // Close the flyout if there are no more layers open and the user is not mousing over the
        // flyout areas (side nav, TopNavStart element)
        return openLayerObserver?.onChange(({ count: count })=>{
            if (flyoutStateRef.current.type === 'ready-to-close' && count === 0) updateFlyoutState('force-close');
        }, {
            namespace: (0, $liCgE.openLayerObserverSideNavNamespace)
        });
    }, [
        openLayerObserver,
        updateFlyoutState
    ]);
    (0, $cozmU.useEffect)(()=>{
        // Clear flyout close timer if being unmounted
        return function cleanupPendingFlyoutClose() {
            if (flyoutStateRef.current.type === 'waiting-for-close') flyoutStateRef.current.abort();
        };
    }, []);
    (0, $g9jMx.useSideNavToggleKeyboardShortcut)({
        canToggleWithShortcut: canToggleWithShortcut
    }); // Used to conditionally display the keyboard shortcut in the SideNavPanelSplitter tooltip.
    const isShortcutEnabled = (0, $d8d8E.useIsSideNavShortcutEnabled)();
    (0, $IRNbu.useResizingWidthCssVarOnRootElement)({
        isEnabled: true,
        cssVar: $69afecb6c46cd616$var$panelSplitterResizingVar,
        panelId: (0, $liCgE.sideNavPanelSplitterId)
    });
    const isExpandedStateDifferentFromInitial = isExpandedOnMobile || isExpandedOnDesktop !== initialIsExpandedOnDesktop; /**
                                                                                                                         * Used to track (between renders) if the expanded state of the side nav has ever changed since mount.
                                                                                                                         *
                                                                                                                         * Cannot rely solely on `isExpandedStateDifferentFromInitial` because the expanded state can go back to the initial state.
                                                                                                                         */ 
    const hasExpandedStateChangedRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (hasExpandedStateChangedRef.current) return;
        if (isExpandedStateDifferentFromInitial) hasExpandedStateChangedRef.current = true;
    }, [
        isExpandedStateDifferentFromInitial
    ]); /**
                                              * If the expanded state of the side nav has ever changed since mount.
                                              *
                                              * Used to prevent sidebar expand animations from running on the initial load.
                                              * Otherwise, the `@starting-style` rule will cause the sidebar to slide in initially.
                                              */ 
    const hasExpandedStateChanged = isExpandedStateDifferentFromInitial || hasExpandedStateChangedRef.current;
    const isMotionUpliftEnabled = (0, $iDrrr.fg)('platform-dst-motion-uplift-sidenav'); // This is only used for the regular expand and collapse animations, not the flyout animations.
    const shouldShowSidebarToggleAnimation = (isMotionUpliftEnabled || isFhsEnabled) && // We do not apply the animation styles on the initial render, as the `@starting-style` rule will cause the sidebar to
    // slide in initially.
    hasExpandedStateChanged && // We also do not apply the animation styles if the side nav is in flyout mode to make sure we don't override flyout styles.
    // If we instead try to unset the `transform` property in the flyout styles using `transform: initial`, it results in the entire
    // flyout animation being disabled.
    !isFlyoutVisible && /**
   * Disabling animations for Firefox, as it doesn't support animating the `display` property:
   * https://caniuse.com/mdn-css_properties_display_is_transitionable
   *
   * As of October 2025, Firefox supports the expand animation, but not the collapse animation (it instantly changes to `display: none`).
   * Because of this, we are disabling all sidebar animations for Firefox so it doesn't look like a bug.
   *
   * Unfortunately we cannot use `@supports` to target the support of `transition-behavior: allow-discrete` specifically
   * for the `display` property. And `@supports at-rule(@starting-style)` is also not ready for browser use yet.
   *
   * We are using JS to detect Firefox and disable animations, instead of using CSS, as Compiled currently does not merge duplicate
   * CSS at-rules when at-rules are nested: https://github.com/atlassian-labs/compiled/blob/e04a325915e1d13010205089e4915de0e53bc2d4/packages/css/src/plugins/merge-duplicate-at-rules.ts#L5
   * Avoiding nesting the `@supports` at-rule inside of `@media` means Compiled can remove duplicate styles from the generated CSS.
   */ !$69afecb6c46cd616$var$isFirefox;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("nav", {
        id: id,
        ...devTimeOnlyAttributes,
        "data-layout-slot": true,
        "aria-label": label,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop
            [(0, $liCgE.sideNavVar)]: clampedWidth
        },
        ref: mergedRef,
        "data-testid": testId,
        className: (0, $hekY6.default)([
            $69afecb6c46cd616$var$styles.root,
            isExpandedOnDesktop && !isExpandedOnMobile && !isFlyoutVisible && $69afecb6c46cd616$var$styles.hiddenMobileOnly,
            !isExpandedOnDesktop && isExpandedOnMobile && !isFlyoutVisible && $69afecb6c46cd616$var$styles.hiddenDesktopOnly,
            !isExpandedOnDesktop && !isExpandedOnMobile && !isFlyoutVisible && $69afecb6c46cd616$var$styles.hiddenMobileAndDesktop,
            isMotionUpliftEnabled && $69afecb6c46cd616$var$motionUpliftStyles.animationRTLSupport,
            !isMotionUpliftEnabled && isFhsEnabled && $69afecb6c46cd616$var$styles.animationRTLSupport,
            shouldShowSidebarToggleAnimation && isMotionUpliftEnabled && $69afecb6c46cd616$var$motionUpliftStyles.animationBaseStyles,
            shouldShowSidebarToggleAnimation && !isMotionUpliftEnabled && $69afecb6c46cd616$var$styles.animationBaseStyles,
            isExpandedOnMobile && shouldShowSidebarToggleAnimation && isMotionUpliftEnabled && $69afecb6c46cd616$var$motionUpliftStyles.expandAnimationMobile,
            isExpandedOnMobile && shouldShowSidebarToggleAnimation && !isMotionUpliftEnabled && $69afecb6c46cd616$var$styles.expandAnimationMobile,
            !isExpandedOnMobile && shouldShowSidebarToggleAnimation && isMotionUpliftEnabled && $69afecb6c46cd616$var$motionUpliftStyles.collapseAnimationMobile,
            !isExpandedOnMobile && shouldShowSidebarToggleAnimation && !isMotionUpliftEnabled && $69afecb6c46cd616$var$styles.collapseAnimationMobile,
            isExpandedOnDesktop && shouldShowSidebarToggleAnimation && isMotionUpliftEnabled && $69afecb6c46cd616$var$motionUpliftStyles.expandAnimationDesktop,
            isExpandedOnDesktop && shouldShowSidebarToggleAnimation && !isMotionUpliftEnabled && $69afecb6c46cd616$var$styles.expandAnimationDesktop,
            !isExpandedOnDesktop && shouldShowSidebarToggleAnimation && isMotionUpliftEnabled && $69afecb6c46cd616$var$motionUpliftStyles.collapseAnimationDesktop,
            !isExpandedOnDesktop && shouldShowSidebarToggleAnimation && !isMotionUpliftEnabled && $69afecb6c46cd616$var$styles.collapseAnimationDesktop,
            sideNavState?.flyout === 'open' && !isFhsEnabled && isMotionUpliftEnabled && $69afecb6c46cd616$var$motionUpliftStyles.flyoutOpen,
            sideNavState?.flyout === 'open' && !isFhsEnabled && !isMotionUpliftEnabled && $69afecb6c46cd616$var$styles.flyoutOpen,
            sideNavState?.flyout === 'triggered-animate-close' && !isFhsEnabled && isMotionUpliftEnabled && $69afecb6c46cd616$var$motionUpliftStyles.flyoutAnimateClosed,
            sideNavState?.flyout === 'triggered-animate-close' && !isFhsEnabled && !isMotionUpliftEnabled && $69afecb6c46cd616$var$styles.flyoutAnimateClosed,
            (sideNavState?.flyout === 'open' || sideNavState?.flyout === 'triggered-animate-close') && !$69afecb6c46cd616$var$isFirefox && isFhsEnabled && $69afecb6c46cd616$var$styles.flyoutBaseStylesFullHeightSidebar,
            sideNavState?.flyout === 'open' && !$69afecb6c46cd616$var$isFirefox && isFhsEnabled && isMotionUpliftEnabled && $69afecb6c46cd616$var$motionUpliftStyles.flyoutOpenFullHeightSidebar,
            sideNavState?.flyout === 'open' && !$69afecb6c46cd616$var$isFirefox && isFhsEnabled && !isMotionUpliftEnabled && $69afecb6c46cd616$var$styles.flyoutOpenFullHeightSidebar,
            sideNavState?.flyout === 'triggered-animate-close' && !$69afecb6c46cd616$var$isFirefox && isFhsEnabled && isMotionUpliftEnabled && $69afecb6c46cd616$var$motionUpliftStyles.flyoutAnimateClosedFullHeightSidebar,
            sideNavState?.flyout === 'triggered-animate-close' && !$69afecb6c46cd616$var$isFirefox && isFhsEnabled && !isMotionUpliftEnabled && $69afecb6c46cd616$var$styles.flyoutAnimateClosedFullHeightSidebar
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aMCy.DangerouslyHoistCssVarToDocumentRoot), {
        variableName: (0, $liCgE.sideNavLiveWidthVar),
        value: "0px",
        mediaQuery: (0, $gnKXs.media).above.md,
        responsiveValue: isExpandedOnDesktop ? `var(${$69afecb6c46cd616$var$panelSplitterResizingVar}, ${clampedWidth})` : 0
    }), dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
    // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
    // When they aren't needed anymore we can delete them wholesale.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aMCy.DangerouslyHoistCssVarToDocumentRoot), {
        variableName: (0, $liCgE.UNSAFE_sideNavLayoutVar),
        value: `var(${(0, $liCgE.sideNavLiveWidthVar)})`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iynkA.PanelSplitterProvider), {
        panelId: (0, $liCgE.sideNavPanelSplitterId),
        panelRef: navRef,
        portalRef: isFhsEnabled ? panelSplitterPortalTargetRef : undefined,
        panelWidth: width,
        onCompleteResize: setWidth,
        getResizeBounds: $69afecb6c46cd616$var$getResizeBounds,
        resizingCssVar: $69afecb6c46cd616$var$panelSplitterResizingVar,
        isEnabled: !isFlyoutVisible,
        shortcut: isShortcutEnabled ? (0, $8CGNp.sideNavToggleTooltipKeyboardShortcut) : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $69afecb6c46cd616$var$styles.flexContainer
        ])
    }, children))), isFhsEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: panelSplitterPortalTargetRef,
        "data-layout-slot": true,
        style: {
            // We need to use an inline style here to share the side nav width to position the panel splitter.
            // We can't use the existing --n_sNvlw variable (sideNavLiveWidthVar) because it is set to 0 when the side nav is collapsed on desktop,
            // however the panel splitter is still visible and usable on small viewports until 48rem.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            [$69afecb6c46cd616$var$sideNavClampedWidthVar]: clampedWidth
        },
        className: (0, $hekY6.default)([
            $69afecb6c46cd616$var$panelSplitterPortalTargetStyles.root,
            isExpandedOnDesktop && !isExpandedOnMobile && !isFlyoutVisible && $69afecb6c46cd616$var$styles.hiddenMobileOnly,
            !isExpandedOnDesktop && isExpandedOnMobile && !isFlyoutVisible && $69afecb6c46cd616$var$styles.hiddenDesktopOnly,
            !isExpandedOnDesktop && !isExpandedOnMobile && !isFlyoutVisible && $69afecb6c46cd616$var$styles.hiddenMobileAndDesktop
        ])
    }));
}
const $69afecb6c46cd616$export$1a35787d6353cf6a = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SideNav(t0) {
    const $ = (0, $bDgLe.c)(13);
    const { children: children, defaultCollapsed: defaultCollapsed, defaultWidth: t1, testId: testId, label: label, skipLinkLabel: t2, onExpand: onExpand, onCollapse: onCollapse, onPeekStart: onPeekStart, onPeekEnd: onPeekEnd, canToggleWithShortcut: canToggleWithShortcut, id: id } = t0;
    const defaultWidth = t1 === undefined ? 320 : t1;
    const skipLinkLabel = t2 === undefined ? label : t2;
    let t3;
    if ($[0] !== canToggleWithShortcut || $[1] !== children || $[2] !== defaultCollapsed || $[3] !== defaultWidth || $[4] !== id || $[5] !== label || $[6] !== onCollapse || $[7] !== onExpand || $[8] !== onPeekEnd || $[9] !== onPeekStart || $[10] !== skipLinkLabel || $[11] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1IrNk.OpenLayerObserverNamespaceProvider), {
            namespace: (0, $liCgE.openLayerObserverSideNavNamespace)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($69afecb6c46cd616$var$SideNavInternal, {
            defaultCollapsed: defaultCollapsed,
            defaultWidth: defaultWidth,
            testId: testId,
            label: label,
            skipLinkLabel: skipLinkLabel,
            onExpand: onExpand,
            onCollapse: onCollapse,
            onPeekStart: onPeekStart,
            onPeekEnd: onPeekEnd,
            id: id,
            canToggleWithShortcut: canToggleWithShortcut
        }, children));
        $[0] = canToggleWithShortcut;
        $[1] = children;
        $[2] = defaultCollapsed;
        $[3] = defaultWidth;
        $[4] = id;
        $[5] = label;
        $[6] = onCollapse;
        $[7] = onExpand;
        $[8] = onPeekEnd;
        $[9] = onPeekStart;
        $[10] = skipLinkLabel;
        $[11] = testId;
        $[12] = t3;
    } else t3 = $[12];
    return t3;
} : function SideNav({ children: children, defaultCollapsed: defaultCollapsed, defaultWidth: defaultWidth = 320, testId: testId, label: label, skipLinkLabel: // Default value is defined in `SideNavInternal`
skipLinkLabel = label, onExpand: // Default value is defined in `SideNavInternal`
onExpand, onCollapse: onCollapse, onPeekStart: onPeekStart, onPeekEnd: onPeekEnd, canToggleWithShortcut: canToggleWithShortcut, id: id }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1IrNk.OpenLayerObserverNamespaceProvider), {
        namespace: (0, $liCgE.openLayerObserverSideNavNamespace)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($69afecb6c46cd616$var$SideNavInternal, {
        defaultCollapsed: defaultCollapsed,
        defaultWidth: defaultWidth,
        testId: testId,
        label: label,
        skipLinkLabel: skipLinkLabel,
        onExpand: onExpand,
        onCollapse: onCollapse,
        onPeekStart: onPeekStart,
        onPeekEnd: onPeekEnd,
        id: id,
        canToggleWithShortcut: canToggleWithShortcut
    }, children));
};
module.exports["SideNav"] = $69afecb6c46cd616$export$1a35787d6353cf6a;

});

parcelRegister("1IrNk", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bB0i2 = parcelRequire("bB0i2");


var $6SYAs = parcelRequire("6SYAs");


var $1wsnZ = parcelRequire("1wsnZ");

const $5a507d5d8d84b171$export$327d0d2a7ae6f7cc = (0, $gtMdU.isReactCompilerActivePlatform)() ? function OpenLayerObserverNamespaceProvider(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { children: children, namespace: namespace } = t0;
    const parentContext = (0, $1wsnZ.useOpenLayerObserverNamespace)();
    let t1;
    let t2;
    if ($[0] !== parentContext) {
        t1 = ()=>{
            (0, $bB0i2.default)(parentContext === null, `An OpenLayerObserver namespace already exists in this component tree: ${parentContext}. Nesting OpenLayerObserverNamespaceProvider is not supported.`);
        };
        t2 = [
            parentContext
        ];
        $[0] = parentContext;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[3] !== children || $[4] !== namespace) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6SYAs.OpenLayerObserverNamespaceContext).Provider, {
            value: namespace,
            children: children
        });
        $[3] = children;
        $[4] = namespace;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : function OpenLayerObserverNamespaceProvider({ children: children, namespace: namespace }) {
    // If there is an existing namespace context being provided, throw an invariant.
    // This use case is not supported at this time.
    const parentContext = (0, $1wsnZ.useOpenLayerObserverNamespace)();
    (0, $cozmU.useEffect)(()=>{
        (0, $bB0i2.default)(parentContext === null, `An OpenLayerObserver namespace already exists in this component tree: ${parentContext}. Nesting OpenLayerObserverNamespaceProvider is not supported.`);
    }, [
        parentContext
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6SYAs.OpenLayerObserverNamespaceContext).Provider, {
        value: namespace,
        children: children
    });
};
module.exports["OpenLayerObserverNamespaceProvider"] = $5a507d5d8d84b171$export$327d0d2a7ae6f7cc;

});

parcelRegister("eaAhc", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7vxJx = parcelRequire("7vxJx");

const $e876544291882b78$export$707b94c26b8b75aa = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { id: id, label: label, listIndex: listIndex, onBeforeNavigate: onBeforeNavigate, navigate: navigate, isHidden: isHidden } = t0;
    const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = (0, $cozmU.useContext)((0, $7vxJx.SkipLinksContext));
    let t1;
    let t2;
    if ($[0] !== id || $[1] !== isHidden || $[2] !== label || $[3] !== listIndex || $[4] !== navigate || $[5] !== onBeforeNavigate || $[6] !== registerSkipLink || $[7] !== unregisterSkipLink) {
        t1 = ()=>{
            if (isHidden) return;
            registerSkipLink({
                id: id,
                label: label,
                listIndex: listIndex,
                onBeforeNavigate: onBeforeNavigate,
                navigate: navigate,
                isHidden: isHidden
            });
            return ()=>{
                unregisterSkipLink(id);
            };
        };
        t2 = [
            id,
            isHidden,
            label,
            listIndex,
            onBeforeNavigate,
            navigate,
            registerSkipLink,
            unregisterSkipLink
        ];
        $[0] = id;
        $[1] = isHidden;
        $[2] = label;
        $[3] = listIndex;
        $[4] = navigate;
        $[5] = onBeforeNavigate;
        $[6] = registerSkipLink;
        $[7] = unregisterSkipLink;
        $[8] = t1;
        $[9] = t2;
    } else {
        t1 = $[8];
        t2 = $[9];
    }
    (0, $cozmU.useEffect)(t1, t2);
} : ({ id: id, label: label, listIndex: listIndex, onBeforeNavigate: onBeforeNavigate, navigate: navigate, isHidden: isHidden })=>{
    const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = (0, $cozmU.useContext)((0, $7vxJx.SkipLinksContext));
    (0, $cozmU.useEffect)(()=>{
        if (isHidden) /**
       * Skip links are hidden for slots with 0 height or width.
       * They should not be registered.
       */ return;
        registerSkipLink({
            id: id,
            label: label,
            listIndex: listIndex,
            onBeforeNavigate: onBeforeNavigate,
            navigate: navigate,
            isHidden: isHidden
        });
        return ()=>{
            unregisterSkipLink(id);
        };
    }, [
        id,
        isHidden,
        label,
        listIndex,
        onBeforeNavigate,
        navigate,
        registerSkipLink,
        unregisterSkipLink
    ]);
};
module.exports["useSkipLinkInternal"] = $e876544291882b78$export$707b94c26b8b75aa;

});

parcelRegister("7vxJx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dpsRj = parcelRequire("dpsRj");

const $17411c769fc5f032$export$4c5cc3b14c7678a = /*#__PURE__*/ (0, $cozmU.createContext)({
    registerSkipLink: (0, $dpsRj.default),
    unregisterSkipLink: (0, $dpsRj.default)
});
module.exports["SkipLinksContext"] = $17411c769fc5f032$export$4c5cc3b14c7678a;

});

parcelRegister("a5Bb1", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $46933863bb9e41c6$export$e9e5087bd319cc8c = /*#__PURE__*/ (0, $cozmU.createContext)(null);
module.exports["TopNavStartElement"] = $46933863bb9e41c6$export$e9e5087bd319cc8c;

});

parcelRegister("4aMCy", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $044d6c64bd91ab11$var$getCssStringValue = (value)=>typeof value === 'number' ? `${value}px` : value;
const $044d6c64bd91ab11$export$9f45a1325e3cdfb8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { variableName: variableName, value: value, mediaQuery: mediaQuery, responsiveValue: responsiveValue } = t0;
    let t1;
    if ($[0] !== value) {
        t1 = $044d6c64bd91ab11$var$getCssStringValue(value);
        $[0] = value;
        $[1] = t1;
    } else t1 = $[1];
    let style = `:root { ${variableName}: ${t1} }`;
    if (mediaQuery && responsiveValue) {
        const t2 = style;
        let t3;
        if ($[2] !== responsiveValue) {
            t3 = $044d6c64bd91ab11$var$getCssStringValue(responsiveValue);
            $[2] = responsiveValue;
            $[3] = t3;
        } else t3 = $[3];
        style = t2 + ` ${mediaQuery} { :root { ${variableName}: ${t3} } }`;
    }
    let t2;
    if ($[4] !== style) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("style", null, style);
        $[4] = style;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ variableName: variableName, value: value, mediaQuery: mediaQuery, responsiveValue: responsiveValue })=>{
    /**
   * Note don't put multiple variables in multiple lines. eg
   * <style>
   *   {css1}
   *   {css2}
   * </style>
   *
   * React will insert an empty HTML comment in between the text in SSR.
   * This is not a valid tag and will break the page.
   * <style>foo<!-- -->bar</style>
   */ let style = `:root { ${variableName}: ${$044d6c64bd91ab11$var$getCssStringValue(value)} }`;
    if (mediaQuery && responsiveValue) style += ` ${mediaQuery} { :root { ${variableName}: ${$044d6c64bd91ab11$var$getCssStringValue(responsiveValue)} } }`;
    return(// Using a global style is required for SSR, as we can't use React hooks
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("style", null, style));
};
module.exports["DangerouslyHoistCssVarToDocumentRoot"] = $044d6c64bd91ab11$export$9f45a1325e3cdfb8;

});

parcelRegister("b24kF", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $487ca48827d0d3da$export$66e2c1a0115af861 = /*#__PURE__*/ (0, $cozmU.createContext)(false);
module.exports["DangerouslyHoistSlotSizes"] = $487ca48827d0d3da$export$66e2c1a0115af861;

});

parcelRegister("eyPWA", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $fG4wV = parcelRequire("fG4wV");

const $92c2259f831194de$export$110c3550c7c1c9aa = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useLayoutId(t0) {
    const $ = (0, $bDgLe.c)(2);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { providedId: providedId } = t1;
    const uniqueId = (0, $fG4wV.useSkipLinkId)();
    const id = providedId ? providedId : uniqueId;
    return id;
} : function useLayoutId({ providedId: providedId } = {}) {
    const uniqueId = (0, $fG4wV.useSkipLinkId)();
    const id = providedId ? providedId : uniqueId;
    return id;
};
module.exports["useLayoutId"] = $92c2259f831194de$export$110c3550c7c1c9aa;

});

parcelRegister("fG4wV", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $6JrSr = parcelRequire("6JrSr");

const $34fa9019e33947fd$export$fa3cfac0c8e29c5c = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useSkipLinkId() {
    const uniqueId = (0, $6JrSr.useId)();
    return uniqueId;
} : function useSkipLinkId() {
    const uniqueId = (0, $6JrSr.useId)();
    return uniqueId;
};
module.exports["useSkipLinkId"] = $34fa9019e33947fd$export$fa3cfac0c8e29c5c;

});

parcelRegister("IRNbu", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $4QfFX = parcelRequire("4QfFX");


var $4Vdlk = parcelRequire("4Vdlk");


var $aLgN8 = parcelRequire("aLgN8");

const $5922881dcb012091$export$d4931ecf0fbcc8fc = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useResizingWidthCssVarOnRootElement(t0) {
    const $ = (0, $bDgLe.c)(9);
    const { isEnabled: t1, cssVar: cssVar, panelId: panelId } = t0;
    const isEnabled = t1 === undefined ? true : t1;
    let t2;
    let t3;
    if ($[0] !== cssVar || $[1] !== isEnabled || $[2] !== panelId) {
        t2 = ()=>{
            if (!isEnabled) return;
            return (0, $4QfFX.combine)((0, $4Vdlk.monitorForElements)({
                canMonitor (t4) {
                    const { source: source } = t4;
                    return source.data.panelId === panelId;
                },
                onDrag (t5) {
                    const { source: source_0 } = t5;
                    if (!(0, $aLgN8.isPanelSplitterDragData)(source_0.data)) return;
                    document.documentElement.style.setProperty(cssVar, source_0.data.resizingWidth);
                },
                onDrop () {
                    document.documentElement.style.removeProperty(cssVar);
                }
            }));
        };
        t3 = [
            cssVar,
            isEnabled,
            panelId
        ];
        $[0] = cssVar;
        $[1] = isEnabled;
        $[2] = panelId;
        $[3] = t2;
        $[4] = t3;
    } else {
        t2 = $[3];
        t3 = $[4];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    let t5;
    if ($[5] !== cssVar || $[6] !== isEnabled) {
        t4 = ()=>{
            if (!isEnabled) return;
            return function cleanupGlobalResizingCssVar() {
                document.documentElement.style.removeProperty(cssVar);
            };
        };
        t5 = [
            cssVar,
            isEnabled
        ];
        $[5] = cssVar;
        $[6] = isEnabled;
        $[7] = t4;
        $[8] = t5;
    } else {
        t4 = $[7];
        t5 = $[8];
    }
    (0, $cozmU.useEffect)(t4, t5);
} : function useResizingWidthCssVarOnRootElement({ isEnabled: isEnabled = true, cssVar: cssVar, panelId: panelId }) {
    (0, $cozmU.useEffect)(()=>{
        if (!isEnabled) return;
        return (0, $4QfFX.combine)((0, $4Vdlk.monitorForElements)({
            canMonitor ({ source: source }) {
                return source.data.panelId === panelId;
            },
            onDrag ({ source: source_0 }) {
                if (!(0, $aLgN8.isPanelSplitterDragData)(source_0.data)) return;
                /**
         * Copies the resizing width value to the `<html>` element.
         *
         * Required to reflect the live width of the side navigation.
         *
         * Used by:
         *   - Legacy `--leftSidebarWidth` variable
         *   - Panel slot max-width constraint
         *
         * When the legacy `--leftSidebarWidth` variable is no longer needed,
         * we could consider writing to the `Panel` element instead.
         */ document.documentElement.style.setProperty(cssVar, source_0.data.resizingWidth);
            },
            onDrop () {
                document.documentElement.style.removeProperty(cssVar);
            }
        }));
    }, [
        cssVar,
        isEnabled,
        panelId
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!isEnabled) return;
        /**
     * Ensures that the resizing CSS var on the `<html>` element is cleaned up properly
     * if the component unmounts during a drag.
     */ return function cleanupGlobalResizingCssVar() {
            document.documentElement.style.removeProperty(cssVar);
        };
    }, [
        cssVar,
        isEnabled
    ]);
};
module.exports["useResizingWidthCssVarOnRootElement"] = $5922881dcb012091$export$d4931ecf0fbcc8fc;

});

parcelRegister("6iHsT", function(module, exports) {
/**
 * Returns the `fallbackWidth` if the provided `defaultWidthProp` is not an integer value.
 */ function $900eefb3c2156b48$export$cff429d7d83ba1f0({ defaultWidthProp: defaultWidthProp, fallbackDefaultWidth: fallbackDefaultWidth, slotName: slotName }) {
    // If the provided `defaultWidth` is invalid then we use our fallback.
    // We are using a runtime check because some invalid numbers like `NaN` are not caught by types,
    // and we saw some issues in products where our experience broke due to this.
    if (!Number.isInteger(defaultWidthProp)) return fallbackDefaultWidth;
    return defaultWidthProp;
}
module.exports["useSafeDefaultWidth"] = $900eefb3c2156b48$export$cff429d7d83ba1f0;

});

parcelRegister("4xyOi", function(module, exports) {
// Note: this value has been pulled into a separate file to better
// support testing with Playwright. Playwright did not like importing
// an exported value from `sidenav.tsx` which has `@jsxRuntime classic`.
//
// Error:
// > importSource cannot be set when runtime is classic.
/**
 * How long the flyout should remain open after the users
 * pointer has left the side nav flyout
 */ const $1d796bc36218efa4$export$a7801e29f563faad = 400;
module.exports["sideNavFlyoutCloseDelayMs"] = $1d796bc36218efa4$export$a7801e29f563faad;

});

parcelRegister("2udoJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dpsRj = parcelRequire("dpsRj");

const $78d3ad3ac2c5fcd5$export$f6b496b07d1ea493 = /*#__PURE__*/ (0, $cozmU.createContext)((0, $dpsRj.default));
module.exports["SetSideNavVisibilityState"] = $78d3ad3ac2c5fcd5$export$f6b496b07d1ea493;

});

parcelRegister("2E6Hq", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $2f1a6650dc7c80f1$export$9c1768094bef896 = /*#__PURE__*/ (0, $cozmU.createContext)(null);
module.exports["SideNavToggleButtonElement"] = $2f1a6650dc7c80f1$export$9c1768094bef896;

});

parcelRegister("8CGNp", function(module, exports) {
/**
 * The keyboard shortcut used in tooltips for indicating how to toggle the side nav.
 *
 * Used in `SideNavToggleButton` and `SideNavPanelSplitter` tooltips.
 */ const $2169f54a5c039586$export$bcd616a79072c3e4 = [
    'Ctrl',
    '['
];
module.exports["sideNavToggleTooltipKeyboardShortcut"] = $2169f54a5c039586$export$bcd616a79072c3e4;

});

parcelRegister("5rNCB", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $eeda3404f6707f04$export$eb04201bb6dd1e4e = /*#__PURE__*/ (0, $cozmU.createContext)(null);
module.exports["SideNavVisibilityState"] = $eeda3404f6707f04$export$eb04201bb6dd1e4e;

});

parcelRegister("aFvBm", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $9kbTQ = parcelRequire("9kbTQ");


var $iDrrr = parcelRequire("iDrrr");


var $2udoJ = parcelRequire("2udoJ");


var $1gX7M = parcelRequire("1gX7M");

/**
 * Moves focus to the first focusable item in the side nav, or the side nav element itself as a fallback.
 */ function $9744c12cac2fb670$var$focusFirstNavItem(sideNavElement) {
    /**
   * Try to get the first focusable item in the side nav.
   * The selector is not very broad, but should be appropriate for items from this package.
   */ const firstNavItem = sideNavElement.querySelector('a, button');
    const isFirstNavItemVisible = firstNavItem !== null && (firstNavItem.checkVisibility?.() ?? false);
    const itemToFocus = isFirstNavItemVisible ? firstNavItem : sideNavElement;
    if (itemToFocus === sideNavElement) {
        /**
     * Elements without an explicit `tabindex` attribute are not guaranteed to be focusable:
     * https://html.spec.whatwg.org/multipage/interaction.html#attr-tabindex
     *
     * Our slots are not interactive, so this is required.
     *
     * In the future we may want to check if there is an existing `tabindex` attribute,
     * as custom skip linked elements might already have one.
     */ sideNavElement.setAttribute('tabindex', '-1');
        /**
     * Cleanup the `tabindex` attribute we set when the slot or custom target loses focus.
     *
     * This is preferable to always having `tabindex="-1"` because always applying the tab index can:
     *
     * - mess with click events
     * - potentially cause a focus ring to be always visible
     */ (0, $cbY7C.bind)(sideNavElement, {
            type: 'blur',
            listener () {
                sideNavElement.removeAttribute('tabindex');
            },
            options: {
                once: true
            }
        });
    }
    /**
   * Not using `focusVisible` option because we don't want clicks on the toggle button to show a focus ring.
   */ itemToFocus.focus();
}
const $9744c12cac2fb670$var$triggersWithFocusOnExpand = new Set([
    'toggle-button',
    'skip-link'
]);
const $9744c12cac2fb670$export$e44b4744d8ff971a = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useExpandSideNav(t0) {
    const $ = (0, $bDgLe.c)(6);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { trigger: t2 } = t1;
    const trigger = t2 === undefined ? "programmatic" : t2;
    const setSideNavState = (0, $cozmU.useContext)((0, $2udoJ.SetSideNavVisibilityState));
    const sideNavRef = (0, $1gX7M.useSideNavRef)();
    let t3;
    if ($[2] !== setSideNavState || $[3] !== sideNavRef || $[4] !== trigger) {
        t3 = ()=>{
            const { matches: isDesktop } = window.matchMedia("(min-width: 64rem)");
            const runUpdate = ()=>{
                if (isDesktop) setSideNavState((currentState)=>{
                    if (!currentState) return null;
                    if (currentState.desktop === "expanded" && currentState.flyout === "closed") return currentState;
                    return {
                        mobile: currentState.mobile,
                        desktop: "expanded",
                        flyout: "closed",
                        lastTrigger: trigger
                    };
                });
                else setSideNavState((currentState_0)=>{
                    if (!currentState_0) return null;
                    if (currentState_0.mobile === "expanded" && currentState_0.flyout === "closed") return currentState_0;
                    return {
                        desktop: currentState_0.desktop,
                        mobile: "expanded",
                        flyout: "closed",
                        lastTrigger: trigger
                    };
                });
            };
            if ($9744c12cac2fb670$var$triggersWithFocusOnExpand.has(trigger) && (0, $iDrrr.fg)("platform_dst_nav4_skip_link_a11y_1")) {
                (0, $9kbTQ.flushSync)(runUpdate);
                const sideNavElement = sideNavRef.current;
                if (sideNavElement) $9744c12cac2fb670$var$focusFirstNavItem(sideNavElement);
            } else runUpdate();
        };
        $[2] = setSideNavState;
        $[3] = sideNavRef;
        $[4] = trigger;
        $[5] = t3;
    } else t3 = $[5];
    const expandSideNav = t3;
    return expandSideNav;
} : function useExpandSideNav({ trigger: trigger = 'programmatic' } = {}) {
    const setSideNavState = (0, $cozmU.useContext)((0, $2udoJ.SetSideNavVisibilityState));
    const sideNavRef = (0, $1gX7M.useSideNavRef)();
    const expandSideNav = (0, $cozmU.useCallback)(()=>{
        const { matches: isDesktop } = window.matchMedia('(min-width: 64rem)');
        const runUpdate = ()=>{
            if (isDesktop) setSideNavState((currentState)=>{
                // No-op if the side nav state has not been initialised yet
                // e.g. if the SideNav has not been mounted yet
                if (!currentState) return null;
                // Skip the re-render if it's a no-op change
                if (currentState.desktop === 'expanded' && currentState.flyout === 'closed') return currentState;
                return {
                    mobile: currentState.mobile,
                    desktop: 'expanded',
                    flyout: 'closed',
                    lastTrigger: trigger
                };
            });
            else setSideNavState((currentState_0)=>{
                // No-op if the side nav state has not been initialised yet
                // e.g. if the SideNav has not been mounted yet
                if (!currentState_0) return null;
                // Skip the re-render if it's a no-op change
                if (currentState_0.mobile === 'expanded' && currentState_0.flyout === 'closed') return currentState_0;
                return {
                    desktop: currentState_0.desktop,
                    mobile: 'expanded',
                    flyout: 'closed',
                    lastTrigger: trigger
                };
            });
        };
        if ($9744c12cac2fb670$var$triggersWithFocusOnExpand.has(trigger) && (0, $iDrrr.fg)('platform_dst_nav4_skip_link_a11y_1')) {
            (0, $9kbTQ.flushSync)(runUpdate);
            const sideNavElement = sideNavRef.current;
            if (sideNavElement) $9744c12cac2fb670$var$focusFirstNavItem(sideNavElement);
        } else runUpdate();
    }, [
        setSideNavState,
        sideNavRef,
        trigger
    ]);
    return expandSideNav;
};
module.exports["useExpandSideNav"] = $9744c12cac2fb670$export$e44b4744d8ff971a;

});

parcelRegister("1gX7M", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $aQh3x = parcelRequire("aQh3x");

const $50ff21347d670a2f$export$fa4d0cff03b1ea4f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useSideNavRef() {
    return (0, $cozmU.useContext)((0, $aQh3x.SideNavRefContext));
} : function useSideNavRef() {
    return (0, $cozmU.useContext)((0, $aQh3x.SideNavRefContext));
};
module.exports["useSideNavRef"] = $50ff21347d670a2f$export$fa4d0cff03b1ea4f;

});

parcelRegister("aQh3x", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $ddeb9803e72f6a24$export$1cd490805a3a9874 = /*#__PURE__*/ (0, $cozmU.createContext)({
    current: null
});
module.exports["SideNavRefContext"] = $ddeb9803e72f6a24$export$1cd490805a3a9874;

});

parcelRegister("d8d8E", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $iaSOX = parcelRequire("iaSOX");

const $3a9506b5e2c493a4$export$be30cdcd17f95ec7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useIsSideNavShortcutEnabled() {
    return (0, $cozmU.useContext)((0, $iaSOX.IsSideNavShortcutEnabledContext));
} : function useIsSideNavShortcutEnabled() {
    return (0, $cozmU.useContext)((0, $iaSOX.IsSideNavShortcutEnabledContext));
};
module.exports["useIsSideNavShortcutEnabled"] = $3a9506b5e2c493a4$export$be30cdcd17f95ec7;

});

parcelRegister("iaSOX", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $4733d63ffc9c0010$export$c41e1ac5602bc8d5 = /*#__PURE__*/ (0, $cozmU.createContext)(false);
module.exports["IsSideNavShortcutEnabledContext"] = $4733d63ffc9c0010$export$c41e1ac5602bc8d5;

});

parcelRegister("g9jMx", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $jyAY3 = parcelRequire("jyAY3");


var $kgGsB = parcelRequire("kgGsB");


var $iDrrr = parcelRequire("iDrrr");


var $1fHIr = parcelRequire("1fHIr");


var $d8d8E = parcelRequire("d8d8E");


var $6NDDH = parcelRequire("6NDDH");

const $51ee361d7fd33029$export$f762e7ac9d86adb0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useSideNavToggleKeyboardShortcut(t0) {
    const $ = (0, $bDgLe.c)(8);
    const { canToggleWithShortcut: canToggleWithShortcut } = t0;
    const isFhsEnabled = (0, $1fHIr.useIsFhsEnabled)();
    const openLayerObserver = (0, $kgGsB.useOpenLayerObserver)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            trigger: "keyboard"
        };
        $[0] = t1;
    } else t1 = $[0];
    const toggleVisibilityByShortcut = (0, $6NDDH.useToggleSideNav)(t1);
    const canToggleWithShortcutStableRef = (0, $jyAY3.default)(canToggleWithShortcut);
    const isSideNavShortcutEnabled = (0, $d8d8E.useIsSideNavShortcutEnabled)();
    let t2;
    let t3;
    if ($[1] !== canToggleWithShortcutStableRef || $[2] !== isFhsEnabled || $[3] !== isSideNavShortcutEnabled || $[4] !== openLayerObserver || $[5] !== toggleVisibilityByShortcut) {
        t2 = ()=>{
            if (!isFhsEnabled && !(0, $iDrrr.fg)("platform-dst-keep-desired-fhs-features")) return;
            if (!isSideNavShortcutEnabled) return;
            return (0, $cbY7C.bind)(window, {
                type: "keydown",
                listener (event) {
                    if (event.ctrlKey && event.key === "[") {
                        if (canToggleWithShortcutStableRef.current && !canToggleWithShortcutStableRef.current()) return;
                        if (event.repeat) return;
                        if (openLayerObserver && openLayerObserver.getCount({
                            type: "modal"
                        }) > 0) return;
                        openLayerObserver?.closeLayers();
                        toggleVisibilityByShortcut();
                    }
                }
            });
        };
        t3 = [
            canToggleWithShortcutStableRef,
            isFhsEnabled,
            isSideNavShortcutEnabled,
            openLayerObserver,
            toggleVisibilityByShortcut
        ];
        $[1] = canToggleWithShortcutStableRef;
        $[2] = isFhsEnabled;
        $[3] = isSideNavShortcutEnabled;
        $[4] = openLayerObserver;
        $[5] = toggleVisibilityByShortcut;
        $[6] = t2;
        $[7] = t3;
    } else {
        t2 = $[6];
        t3 = $[7];
    }
    (0, $cozmU.useEffect)(t2, t3);
} : function useSideNavToggleKeyboardShortcut({ canToggleWithShortcut: canToggleWithShortcut }) {
    const isFhsEnabled = (0, $1fHIr.useIsFhsEnabled)();
    const openLayerObserver = (0, $kgGsB.useOpenLayerObserver)();
    const toggleVisibilityByShortcut = (0, $6NDDH.useToggleSideNav)({
        trigger: 'keyboard'
    });
    const canToggleWithShortcutStableRef = (0, $jyAY3.default)(canToggleWithShortcut);
    const isSideNavShortcutEnabled = (0, $d8d8E.useIsSideNavShortcutEnabled)();
    (0, $cozmU.useEffect)(()=>{
        if (!isFhsEnabled && !(0, $iDrrr.fg)('platform-dst-keep-desired-fhs-features')) return;
        if (!isSideNavShortcutEnabled) return;
        return (0, $cbY7C.bind)(window, {
            type: 'keydown',
            listener (event) {
                if (event.ctrlKey && event.key === '[') {
                    if (canToggleWithShortcutStableRef.current && !canToggleWithShortcutStableRef.current()) // Return early if the callback returns false.
                    // If the callback is not provided, we assume the shortcut is enabled.
                    return;
                    if (event.repeat) // Ignore repeated keydown events from holding down the keys
                    return;
                    if (openLayerObserver && openLayerObserver.getCount({
                        type: 'modal'
                    }) > 0) // Return early if there are any open modals
                    return;
                    openLayerObserver?.closeLayers();
                    toggleVisibilityByShortcut();
                }
            }
        });
    }, [
        canToggleWithShortcutStableRef,
        isFhsEnabled,
        isSideNavShortcutEnabled,
        openLayerObserver,
        toggleVisibilityByShortcut
    ]);
};
module.exports["useSideNavToggleKeyboardShortcut"] = $51ee361d7fd33029$export$f762e7ac9d86adb0;

});

parcelRegister("6NDDH", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $2udoJ = parcelRequire("2udoJ");


var $5rNCB = parcelRequire("5rNCB");


var $aFvBm = parcelRequire("aFvBm");

const $85245a7ff1efb457$export$477ee35601a0a8ce = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useToggleSideNav(t0) {
    const $ = (0, $bDgLe.c)(10);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { trigger: t2 } = t1;
    const trigger = t2 === undefined ? "programmatic" : t2;
    const setSideNavState = (0, $cozmU.useContext)((0, $2udoJ.SetSideNavVisibilityState));
    const sideNavState = (0, $cozmU.useContext)((0, $5rNCB.SideNavVisibilityState));
    let t3;
    if ($[2] !== trigger) {
        t3 = {
            trigger: trigger
        };
        $[2] = trigger;
        $[3] = t3;
    } else t3 = $[3];
    const expandSideNav = (0, $aFvBm.useExpandSideNav)(t3);
    const isCollapsedOnDesktop = sideNavState?.desktop === "collapsed";
    const isCollapsedOnMobile = sideNavState?.mobile === "collapsed";
    let t4;
    if ($[4] !== expandSideNav || $[5] !== isCollapsedOnDesktop || $[6] !== isCollapsedOnMobile || $[7] !== setSideNavState || $[8] !== trigger) {
        t4 = ()=>{
            const { matches: isDesktop } = window.matchMedia("(min-width: 64rem)");
            if ((0, $iDrrr.fg)("platform_dst_nav4_skip_link_a11y_1")) {
                const isExpanding = isDesktop ? isCollapsedOnDesktop : isCollapsedOnMobile;
                if (isExpanding) expandSideNav();
                else setSideNavState((currentState)=>{
                    if (!currentState) return null;
                    return {
                        mobile: isDesktop ? currentState.mobile : "collapsed",
                        desktop: isDesktop ? "collapsed" : currentState.desktop,
                        flyout: "closed",
                        lastTrigger: trigger
                    };
                });
                return;
            }
            if (isDesktop) setSideNavState((currentState_0)=>{
                if (!currentState_0) return null;
                return {
                    mobile: currentState_0.mobile,
                    desktop: currentState_0.desktop === "expanded" ? "collapsed" : "expanded",
                    flyout: "closed",
                    lastTrigger: trigger
                };
            });
            else setSideNavState((currentState_1)=>{
                if (!currentState_1) return null;
                return {
                    desktop: currentState_1.desktop,
                    mobile: currentState_1.mobile === "expanded" ? "collapsed" : "expanded",
                    flyout: "closed",
                    lastTrigger: trigger
                };
            });
        };
        $[4] = expandSideNav;
        $[5] = isCollapsedOnDesktop;
        $[6] = isCollapsedOnMobile;
        $[7] = setSideNavState;
        $[8] = trigger;
        $[9] = t4;
    } else t4 = $[9];
    const toggleSideNav = t4;
    return toggleSideNav;
} : function useToggleSideNav({ trigger: trigger = 'programmatic' } = {}) {
    const setSideNavState = (0, $cozmU.useContext)((0, $2udoJ.SetSideNavVisibilityState));
    const sideNavState = (0, $cozmU.useContext)((0, $5rNCB.SideNavVisibilityState));
    const expandSideNav = (0, $aFvBm.useExpandSideNav)({
        trigger: trigger
    });
    const isCollapsedOnDesktop = sideNavState?.desktop === 'collapsed';
    const isCollapsedOnMobile = sideNavState?.mobile === 'collapsed';
    const toggleSideNav = (0, $cozmU.useCallback)(()=>{
        const { matches: isDesktop } = window.matchMedia('(min-width: 64rem)');
        if ((0, $iDrrr.fg)('platform_dst_nav4_skip_link_a11y_1')) {
            const isExpanding = isDesktop ? isCollapsedOnDesktop : isCollapsedOnMobile;
            if (isExpanding) expandSideNav();
            else setSideNavState((currentState)=>{
                // No-op if the side nav state has not been initialised yet
                // e.g. if the SideNav has not been mounted yet
                if (!currentState) return null;
                return {
                    mobile: isDesktop ? currentState.mobile : 'collapsed',
                    desktop: isDesktop ? 'collapsed' : currentState.desktop,
                    flyout: 'closed',
                    lastTrigger: trigger
                };
            });
            return;
        }
        if (isDesktop) setSideNavState((currentState_0)=>{
            // No-op if the side nav state has not been initialised yet
            // e.g. if the SideNav has not been mounted yet
            if (!currentState_0) return null;
            return {
                mobile: currentState_0.mobile,
                desktop: currentState_0.desktop === 'expanded' ? 'collapsed' : 'expanded',
                flyout: 'closed',
                lastTrigger: trigger
            };
        });
        else setSideNavState((currentState_1)=>{
            // No-op if the side nav state has not been initialised yet
            // e.g. if the SideNav has not been mounted yet
            if (!currentState_1) return null;
            return {
                desktop: currentState_1.desktop,
                mobile: currentState_1.mobile === 'expanded' ? 'collapsed' : 'expanded',
                flyout: 'closed',
                lastTrigger: trigger
            };
        });
    }, [
        expandSideNav,
        isCollapsedOnDesktop,
        isCollapsedOnMobile,
        setSideNavState,
        trigger
    ]);
    return toggleSideNav;
};
module.exports["useToggleSideNav"] = $85245a7ff1efb457$export$477ee35601a0a8ce;

});

parcelRegister("gjVTm", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5rNCB = parcelRequire("5rNCB");

const $ef249aefe62a86fe$export$4a602ad7e09bdb2c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { defaultCollapsed: t2 } = t1;
    const defaultCollapsed = t2 === undefined ? false : t2;
    const sideNavState = (0, $cozmU.useContext)((0, $5rNCB.SideNavVisibilityState));
    if (sideNavState === null) {
        const t3 = !defaultCollapsed;
        let t4;
        if ($[2] !== t3) {
            t4 = {
                isExpandedOnDesktop: t3,
                isExpandedOnMobile: false
            };
            $[2] = t3;
            $[3] = t4;
        } else t4 = $[3];
        return t4;
    }
    const t3 = sideNavState.desktop === "expanded";
    const t4 = sideNavState.mobile === "expanded";
    let t5;
    if ($[4] !== t3 || $[5] !== t4) {
        t5 = {
            isExpandedOnDesktop: t3,
            isExpandedOnMobile: t4
        };
        $[4] = t3;
        $[5] = t4;
        $[6] = t5;
    } else t5 = $[6];
    return t5;
} : ({ defaultCollapsed: defaultCollapsed = false } = {})=>{
    const sideNavState = (0, $cozmU.useContext)((0, $5rNCB.SideNavVisibilityState));
    // If the context value is `null`, it means we are still in SSR, and should use the default values.
    // For desktop, it comes from the `defaultCollapsed` prop, and for mobile, it is always `false`.
    if (sideNavState === null) return {
        isExpandedOnDesktop: !defaultCollapsed,
        isExpandedOnMobile: false
    };
    return {
        isExpandedOnDesktop: sideNavState.desktop === 'expanded',
        isExpandedOnMobile: sideNavState.mobile === 'expanded'
    };
};
module.exports["useSideNavVisibility"] = $ef249aefe62a86fe$export$4a602ad7e09bdb2c;

});

parcelRegister("7PUR3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6iJ3v = parcelRequire("6iJ3v");

const $bea74fa628ffec08$export$1904b8f2577aba9a = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useSideNavVisibilityCallbacks(t0) {
    const $ = (0, $bDgLe.c)(14);
    const { onExpand: onExpand, onCollapse: onCollapse, isExpandedOnDesktop: isExpandedOnDesktop, isExpandedOnMobile: isExpandedOnMobile, lastTrigger: lastTrigger } = t0;
    const onExpandRef = (0, $cozmU.useRef)(onExpand);
    const onCollapseRef = (0, $cozmU.useRef)(onCollapse);
    let t1;
    let t2;
    if ($[0] !== onCollapse || $[1] !== onExpand) {
        t1 = ()=>{
            onExpandRef.current = onExpand;
            onCollapseRef.current = onCollapse;
        };
        t2 = [
            onExpand,
            onCollapse
        ];
        $[0] = onCollapse;
        $[1] = onExpand;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $cozmU.useEffect)(t1, t2);
    const previousIsExpandedOnDesktop = (0, $6iJ3v.default)(isExpandedOnDesktop);
    let t3;
    let t4;
    if ($[4] !== isExpandedOnDesktop || $[5] !== lastTrigger || $[6] !== previousIsExpandedOnDesktop) {
        t3 = ()=>{
            if (previousIsExpandedOnDesktop === undefined || previousIsExpandedOnDesktop === isExpandedOnDesktop) return;
            if (isExpandedOnDesktop) onExpandRef.current?.({
                screen: "desktop",
                trigger: lastTrigger
            });
            else onCollapseRef.current?.({
                screen: "desktop",
                trigger: lastTrigger
            });
        };
        t4 = [
            previousIsExpandedOnDesktop,
            isExpandedOnDesktop,
            lastTrigger
        ];
        $[4] = isExpandedOnDesktop;
        $[5] = lastTrigger;
        $[6] = previousIsExpandedOnDesktop;
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $cozmU.useEffect)(t3, t4);
    const previousIsExpandedOnMobile = (0, $6iJ3v.default)(isExpandedOnMobile);
    let t5;
    let t6;
    if ($[9] !== isExpandedOnMobile || $[10] !== lastTrigger || $[11] !== previousIsExpandedOnMobile) {
        t5 = ()=>{
            if (previousIsExpandedOnMobile === undefined || previousIsExpandedOnMobile === isExpandedOnMobile) return;
            if (isExpandedOnMobile) onExpandRef.current?.({
                screen: "mobile",
                trigger: lastTrigger
            });
            else onCollapseRef.current?.({
                screen: "mobile",
                trigger: lastTrigger
            });
        };
        t6 = [
            previousIsExpandedOnMobile,
            isExpandedOnMobile,
            lastTrigger
        ];
        $[9] = isExpandedOnMobile;
        $[10] = lastTrigger;
        $[11] = previousIsExpandedOnMobile;
        $[12] = t5;
        $[13] = t6;
    } else {
        t5 = $[12];
        t6 = $[13];
    }
    (0, $cozmU.useEffect)(t5, t6);
} : function useSideNavVisibilityCallbacks({ onExpand: onExpand, onCollapse: onCollapse, isExpandedOnDesktop: isExpandedOnDesktop, isExpandedOnMobile: isExpandedOnMobile, lastTrigger: lastTrigger }) {
    // Wrapping in refs so we can call them in `useEffect` without changes to them triggering the `useEffect`
    const onExpandRef = (0, $cozmU.useRef)(onExpand);
    const onCollapseRef = (0, $cozmU.useRef)(onCollapse);
    (0, $cozmU.useEffect)(()=>{
        onExpandRef.current = onExpand;
        onCollapseRef.current = onCollapse;
    }, [
        onExpand,
        onCollapse
    ]);
    const previousIsExpandedOnDesktop = (0, $6iJ3v.default)(isExpandedOnDesktop);
    (0, $cozmU.useEffect)(()=>{
        if (previousIsExpandedOnDesktop === undefined || previousIsExpandedOnDesktop === isExpandedOnDesktop) /**
       * The previous value is `undefined` on initialization, so if it is `undefined` then the value hasn't changed.
       *
       * The previous value can be equal to the current one if the component re-renders due to something else changing.
       *
       * In both cases the value hasn't changed and we don't want to notify consumers.
       */ return;
        if (isExpandedOnDesktop) onExpandRef.current?.({
            screen: 'desktop',
            trigger: lastTrigger
        });
        else onCollapseRef.current?.({
            screen: 'desktop',
            trigger: lastTrigger
        });
    }, [
        previousIsExpandedOnDesktop,
        isExpandedOnDesktop,
        lastTrigger
    ]);
    const previousIsExpandedOnMobile = (0, $6iJ3v.default)(isExpandedOnMobile);
    (0, $cozmU.useEffect)(()=>{
        if (previousIsExpandedOnMobile === undefined || previousIsExpandedOnMobile === isExpandedOnMobile) /**
       * The previous value is `undefined` on initialization, so if it is `undefined` then the value hasn't changed.
       *
       * The previous value can be equal to the current one if the component re-renders due to something else changing.
       *
       * In both cases the value hasn't changed and we don't want to notify consumers.
       */ return;
        if (isExpandedOnMobile) onExpandRef.current?.({
            screen: 'mobile',
            trigger: lastTrigger
        });
        else onCollapseRef.current?.({
            screen: 'mobile',
            trigger: lastTrigger
        });
    }, [
        previousIsExpandedOnMobile,
        isExpandedOnMobile,
        lastTrigger
    ]);
};
module.exports["useSideNavVisibilityCallbacks"] = $bea74fa628ffec08$export$1904b8f2577aba9a;

});

parcelRegister("4oUV5", function(module, exports) {
/* side-nav-content.tsx generated by @compiled/babel-plugin v3.0.1 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $lmzCg = parcelRequire("lmzCg");


var $1fHIr = parcelRequire("1fHIr");

const $c2e0995421fdf372$export$28f21f3651df4fa1 = /*#__PURE__*/ (0, $cozmU.forwardRef)($c2e0995421fdf372$var$_SideNavContent); // Placing this const below the function breaks Compiled!
const $c2e0995421fdf372$var$styles = {
    scrollContainer: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4bt5LAIZbP _2WAcuGIZbP",
    paddingContainer: "_46hvQm8HPE _03SyCP8HPE _0xmtko8HPE _0LQT5E8HPE"
};
function $c2e0995421fdf372$var$_SideNavContent({ children: children, testId: testId }, forwardedRef) {
    const isFhsEnabled = (0, $1fHIr.useIsFhsEnabled)();
    const internalRef = (0, $cozmU.useRef)(null);
    const mergedRef = (0, $cozmU.useMemo)(()=>(0, $lmzCg.default)([
            internalRef,
            forwardedRef
        ]), [
        forwardedRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: isFhsEnabled ? mergedRef : forwardedRef,
        "data-testid": testId,
        className: (0, $hekY6.default)([
            $c2e0995421fdf372$var$styles.scrollContainer
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $c2e0995421fdf372$var$styles.paddingContainer
        ])
    }, children));
}
module.exports["SideNavBody"] = $c2e0995421fdf372$export$28f21f3651df4fa1;

});

parcelRegister("jHtN7", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $17592f56d6d8f4dd$var$styles = {
    root: "_46hvQm8HPE _03SyCP8HPE _0xmtko8HPE _0LQT5E8HPE _0vfIXINvrM _4hyvPa6wH8 _1KhSQW9r67"
}; /**
    * The bottom part of the side nav.
    */ 
const $17592f56d6d8f4dd$export$b773c4c9cf740fbe = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { children: children, xcss: xcss } = t0;
    let t1;
    if ($[0] !== xcss) {
        t1 = (0, $hekY6.default)([
            $17592f56d6d8f4dd$var$styles.root,
            xcss
        ]);
        $[0] = xcss;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children || $[3] !== t1) {
        t2 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t1
        }, children);
        $[2] = children;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ children: /**
   * The content of the layout area.
   */ children, xcss: xcss })=>{
    return /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $17592f56d6d8f4dd$var$styles.root,
            xcss
        ])
    }, children);
};
module.exports["SideNavFooter"] = $17592f56d6d8f4dd$export$b773c4c9cf740fbe;

});

parcelRegister("kynDG", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $15dbae337da11376$var$styles = {
    root: "_2Y7lL48HPE _46hvQm8HPE _0xmtko1Y8M"
}; /**
    * The top part of the side nav.
    */ 
const $15dbae337da11376$export$9d28ff3a0d89869c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            $15dbae337da11376$var$styles.root
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t1
        }, children);
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ children: children })=>{
    return /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $15dbae337da11376$var$styles.root
        ])
    }, children);
};
module.exports["SideNavHeader"] = $15dbae337da11376$export$9d28ff3a0d89869c;

});

parcelRegister("jYwSK", function(module, exports) {
/**
 * @generated — manual edits won't persist!
 * Shim sources: platform/build/monorepo-utils/deprecation-removal-recovery/index.js
 * Regenerate: node platform/build/monorepo-utils/deprecation-removal-recovery/generate-shims.js
 */ 
var $gP8zs = parcelRequire("gP8zs");

module.exports = Object.assign({}, $gP8zs, {
    SideNavContent: $gP8zs.SideNavBody
});
if ($gP8zs.__esModule) Object.defineProperty(module.exports, '__esModule', {
    value: true
});

});

parcelRegister("gP8zs", function(module, exports) {
$parcel$export(module.exports, "SideNav", () => (parcelRequire("eCqXP")).SideNav);
$parcel$export(module.exports, "SideNavHeader", () => (parcelRequire("kynDG")).SideNavHeader);
$parcel$export(module.exports, "SideNavBody", () => (parcelRequire("4oUV5")).SideNavBody);
$parcel$export(module.exports, "SideNavFooter", () => (parcelRequire("jHtN7")).SideNavFooter);
$parcel$export(module.exports, "SideNavToggleButton", () => (parcelRequire("dtHQ4")).SideNavToggleButton);
$parcel$export(module.exports, "useToggleSideNav", () => (parcelRequire("6NDDH")).useToggleSideNav);
$parcel$export(module.exports, "useExpandSideNav", () => (parcelRequire("aFvBm")).useExpandSideNav);
$parcel$export(module.exports, "useSideNavRef", () => (parcelRequire("1gX7M")).useSideNavRef);
$parcel$export(module.exports, "SideNavPanelSplitter", () => (parcelRequire("5Pqwh")).SideNavPanelSplitter);

var $eCqXP = parcelRequire("eCqXP");


var $kynDG = parcelRequire("kynDG");


var $4oUV5 = parcelRequire("4oUV5");


var $jHtN7 = parcelRequire("jHtN7");


var $dtHQ4 = parcelRequire("dtHQ4");


var $6NDDH = parcelRequire("6NDDH");


var $aFvBm = parcelRequire("aFvBm");


var $1gX7M = parcelRequire("1gX7M");


var $5Pqwh = parcelRequire("5Pqwh");


});

parcelRegister("dtHQ4", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $9DHhW = parcelRequire("9DHhW");


var $gzlgs = parcelRequire("gzlgs");


var $1pYOd = parcelRequire("1pYOd");


var $kgGsB = parcelRequire("kgGsB");


var $iDrrr = parcelRequire("iDrrr");


var $1fHIr = parcelRequire("1fHIr");


var $bZTfQ = parcelRequire("bZTfQ");


var $lu8mP = parcelRequire("lu8mP");


var $8CGNp = parcelRequire("8CGNp");


var $5rNCB = parcelRequire("5rNCB");


var $d8d8E = parcelRequire("d8d8E");


var $gjVTm = parcelRequire("gjVTm");


var $6NDDH = parcelRequire("6NDDH");

const $ee8db6bac2a63753$var$toggleButtonTooltipOptions = {
    // We're disabling pointer events on the tooltip to prevent it from blocking mouse events, so that the side nav flyout stays open
    // when moving the mouse from the top bar to the side nav.
    ignoreTooltipPointerEvents: true
}; // For duplicate "mouseenter" issue when changing icons (see below)
const $ee8db6bac2a63753$var$silentIconStyles = null; /**
                                * __SideNavToggleButton__
                                *
                                * Button for toggling the side nav. It should be used in the top bar.
                                */ 
const $ee8db6bac2a63753$export$8bd77667631fec25 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(36);
    const { defaultCollapsed: t1, expandLabel: expandLabel, collapseLabel: collapseLabel, testId: testId, interactionName: interactionName, onClick: onClick } = t0;
    const defaultCollapsed = t1 === undefined ? false : t1;
    const isFhsEnabled = (0, $1fHIr.useIsFhsEnabled)();
    let t2;
    if ($[0] !== defaultCollapsed) {
        t2 = {
            defaultCollapsed: defaultCollapsed
        };
        $[0] = defaultCollapsed;
        $[1] = t2;
    } else t2 = $[1];
    const { isExpandedOnDesktop: isSideNavExpandedOnDesktop, isExpandedOnMobile: isSideNavExpandedOnMobile } = (0, $gjVTm.useSideNavVisibility)(t2);
    const sideNavState = (0, $cozmU.useContext)((0, $5rNCB.SideNavVisibilityState));
    const [isSideNavExpanded, setIsSideNavExpanded] = (0, $cozmU.useState)(sideNavState === null ? !defaultCollapsed : isSideNavExpandedOnDesktop);
    const ref = (0, $cozmU.useContext)((0, $lu8mP.SideNavToggleButtonAttachRef));
    const [element, setElement] = (0, $cozmU.useState)(null);
    let t3;
    let t4;
    if ($[2] !== element || $[3] !== ref) {
        t3 = ()=>{
            ref(element);
        };
        t4 = [
            element,
            ref
        ];
        $[2] = element;
        $[3] = ref;
        $[4] = t3;
        $[5] = t4;
    } else {
        t3 = $[4];
        t4 = $[5];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    let t6;
    if ($[6] !== isSideNavExpandedOnDesktop || $[7] !== isSideNavExpandedOnMobile) {
        t5 = ()=>{
            const { matches: matches } = window.matchMedia("(min-width: 64rem)");
            setIsSideNavExpanded(matches ? isSideNavExpandedOnDesktop : isSideNavExpandedOnMobile);
        };
        t6 = [
            isSideNavExpandedOnDesktop,
            isSideNavExpandedOnMobile
        ];
        $[6] = isSideNavExpandedOnDesktop;
        $[7] = isSideNavExpandedOnMobile;
        $[8] = t5;
        $[9] = t6;
    } else {
        t5 = $[8];
        t6 = $[9];
    }
    (0, $cozmU.useEffect)(t5, t6);
    let t7;
    let t8;
    if ($[10] !== isSideNavExpandedOnDesktop || $[11] !== isSideNavExpandedOnMobile) {
        t7 = ()=>{
            const mediaQueryList = window.matchMedia("(min-width: 64rem)");
            return (0, $cbY7C.bind)(mediaQueryList, {
                type: "change",
                listener () {
                    setIsSideNavExpanded(mediaQueryList.matches ? isSideNavExpandedOnDesktop : isSideNavExpandedOnMobile);
                }
            });
        };
        t8 = [
            isSideNavExpandedOnDesktop,
            isSideNavExpandedOnMobile
        ];
        $[10] = isSideNavExpandedOnDesktop;
        $[11] = isSideNavExpandedOnMobile;
        $[12] = t7;
        $[13] = t8;
    } else {
        t7 = $[12];
        t8 = $[13];
    }
    (0, $cozmU.useEffect)(t7, t8);
    let t9;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = {
            trigger: "toggle-button"
        };
        $[14] = t9;
    } else t9 = $[14];
    const toggleVisibility = (0, $6NDDH.useToggleSideNav)(t9);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const openLayerObserver = (0, $kgGsB.useOpenLayerObserver)();
    let t10;
    if ($[15] !== isFhsEnabled || $[16] !== isSideNavExpanded || $[17] !== onClick || $[18] !== openLayerObserver || $[19] !== toggleVisibility) {
        t10 = (event, analyticsEvent)=>{
            onClick?.(event, analyticsEvent, {
                isSideNavVisible: isSideNavExpanded
            });
            toggleVisibility();
            if (isFhsEnabled || (0, $iDrrr.fg)("platform-dst-keep-desired-fhs-features")) openLayerObserver?.closeLayers();
        };
        $[15] = isFhsEnabled;
        $[16] = isSideNavExpanded;
        $[17] = onClick;
        $[18] = openLayerObserver;
        $[19] = toggleVisibility;
        $[20] = t10;
    } else t10 = $[20];
    const handleClick = t10;
    let t11;
    if ($[21] !== createAnalyticsEvent || $[22] !== isSideNavExpanded) {
        t11 = ()=>{
            const isDesktop = window.matchMedia("(min-width: 64rem)").matches;
            if (!isDesktop) return;
            const navigationAnalyticsEvent = createAnalyticsEvent({
                source: "topNav",
                actionSubject: "sideNav",
                action: "hovered",
                actionSubjectId: "sideNavButton",
                attributes: {
                    itemState: isSideNavExpanded ? "expanded" : "collapsed",
                    screen: "desktop"
                }
            });
            navigationAnalyticsEvent.fire("navigation");
        };
        $[21] = createAnalyticsEvent;
        $[22] = isSideNavExpanded;
        $[23] = t11;
    } else t11 = $[23];
    const handlePointerEnter = t11;
    let t12;
    if ($[24] !== isSideNavExpanded) {
        t12 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                className: (0, $hekY6.default)([
                    "_3iDTPbcK7c _1pp6NdYbGa"
                ])
            }, isSideNavExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gzlgs))), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1pYOd))), props));
        $[24] = isSideNavExpanded;
        $[25] = t12;
    } else t12 = $[25];
    const icon = t12;
    const isShortcutEnabled = (0, $d8d8E.useIsSideNavShortcutEnabled)();
    let t13;
    bb0: {
        if (isFhsEnabled || (0, $iDrrr.fg)("platform-dst-keep-desired-fhs-features")) {
            const t14 = isShortcutEnabled ? (0, $8CGNp.sideNavToggleTooltipKeyboardShortcut) : undefined;
            let t15;
            if ($[26] !== t14) {
                t15 = {
                    ...$ee8db6bac2a63753$var$toggleButtonTooltipOptions,
                    shortcut: t14
                };
                $[26] = t14;
                $[27] = t15;
            } else t15 = $[27];
            t13 = t15;
            break bb0;
        }
        t13 = $ee8db6bac2a63753$var$toggleButtonTooltipOptions;
    }
    const tooltipProps = t13;
    const t14 = isSideNavExpanded ? collapseLabel : expandLabel;
    let t15;
    if ($[28] !== handleClick || $[29] !== handlePointerEnter || $[30] !== icon || $[31] !== interactionName || $[32] !== t14 || $[33] !== testId || $[34] !== tooltipProps) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bZTfQ.IconButton), {
            appearance: "subtle",
            label: t14,
            icon: icon,
            onClick: handleClick,
            onPointerEnter: handlePointerEnter,
            testId: testId,
            isTooltipDisabled: false,
            interactionName: interactionName,
            ref: setElement,
            tooltip: tooltipProps
        });
        $[28] = handleClick;
        $[29] = handlePointerEnter;
        $[30] = icon;
        $[31] = interactionName;
        $[32] = t14;
        $[33] = testId;
        $[34] = tooltipProps;
        $[35] = t15;
    } else t15 = $[35];
    return t15;
} : ({ defaultCollapsed: defaultCollapsed = false, expandLabel: expandLabel, collapseLabel: collapseLabel, testId: testId, interactionName: interactionName, onClick: onClick })=>{
    const isFhsEnabled = (0, $1fHIr.useIsFhsEnabled)();
    const { isExpandedOnDesktop: isSideNavExpandedOnDesktop, isExpandedOnMobile: isSideNavExpandedOnMobile } = (0, $gjVTm.useSideNavVisibility)({
        defaultCollapsed: defaultCollapsed
    });
    const sideNavState = (0, $cozmU.useContext)((0, $5rNCB.SideNavVisibilityState)); // When default state is provided to `Root` the state in context will already be
    // initialized in SSR
    const [isSideNavExpanded, setIsSideNavExpanded] = (0, $cozmU.useState)(sideNavState === null ? !defaultCollapsed : isSideNavExpandedOnDesktop);
    const ref = (0, $cozmU.useContext)((0, $lu8mP.SideNavToggleButtonAttachRef)); /**
                                                         * Addresses HOT-121458 by ensuring that the toggle button element in context is always up to date.
                                                         *
                                                         * My theory is that something to do with SSR, hydration and suspense was causing the
                                                         * underlying HTML element to change but without causing the toggle button to remount.
                                                         *
                                                         * This meant the effect calling `ref()` did not re-run, and the value in context became stale.
                                                         */ 
    const [element, setElement] = (0, $cozmU.useState)(null);
    (0, $cozmU.useEffect)(()=>{
        ref(element);
    }, [
        element,
        ref
    ]);
    (0, $cozmU.useEffect)(()=>{
        const { matches: matches } = window.matchMedia('(min-width: 64rem)');
        setIsSideNavExpanded(matches ? isSideNavExpandedOnDesktop : isSideNavExpandedOnMobile);
    }, [
        isSideNavExpandedOnDesktop,
        isSideNavExpandedOnMobile
    ]);
    (0, $cozmU.useEffect)(()=>{
        // When screen size changes, ensure we use the correct visibility state
        const mediaQueryList = window.matchMedia('(min-width: 64rem)');
        return (0, $cbY7C.bind)(mediaQueryList, {
            type: 'change',
            listener () {
                setIsSideNavExpanded(mediaQueryList.matches ? isSideNavExpandedOnDesktop : isSideNavExpandedOnMobile);
            }
        });
    }, [
        isSideNavExpandedOnDesktop,
        isSideNavExpandedOnMobile
    ]);
    const toggleVisibility = (0, $6NDDH.useToggleSideNav)({
        trigger: 'toggle-button'
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const openLayerObserver = (0, $kgGsB.useOpenLayerObserver)();
    const handleClick = (0, $cozmU.useCallback)((event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent, {
            isSideNavVisible: isSideNavExpanded
        });
        toggleVisibility();
        if (isFhsEnabled || (0, $iDrrr.fg)('platform-dst-keep-desired-fhs-features')) openLayerObserver?.closeLayers();
    }, [
        isFhsEnabled,
        isSideNavExpanded,
        onClick,
        openLayerObserver,
        toggleVisibility
    ]);
    const handlePointerEnter = (0, $cozmU.useCallback)(()=>{
        // Hovers don't do anything on mobile, so not capturing
        const isDesktop = window.matchMedia('(min-width: 64rem)').matches;
        if (!isDesktop) return;
        const navigationAnalyticsEvent = createAnalyticsEvent({
            source: 'topNav',
            actionSubject: 'sideNav',
            action: 'hovered',
            actionSubjectId: 'sideNavButton',
            attributes: {
                itemState: isSideNavExpanded ? 'expanded' : 'collapsed',
                screen: 'desktop'
            }
        });
        navigationAnalyticsEvent.fire('navigation');
    }, [
        createAnalyticsEvent,
        isSideNavExpanded
    ]); /**
                                                  * ## Behaviour
                                                  * It is intentional that collapse icon will be used while the flyout is open.
                                                  * The icon is tied to the expanded / collapse state, and not the flyout state.
                                                  *
                                                  * ## Why a function?
                                                  * Unfortunately, changing the icon inside an <IconButton> when the user is over
                                                  * the button will cause the svg element to be replaced, which can trigger a
                                                  * "mouseenter" event. This is problematic when the user is already over the button,
                                                  * as it can result in a "mouseenter" event after the user manually entered the button.
                                                  *
                                                  * `icon` accepts a function for the `icon` prop (ie a render prop), so we don't need to
                                                  * memoize it, or pull it out into a new function
                                                  */ 
    const icon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            className: (0, $hekY6.default)([
                "_3iDTPbcK7c _1pp6NdYbGa"
            ])
        }, isSideNavExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gzlgs))), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1pYOd))), props));
    const isShortcutEnabled = (0, $d8d8E.useIsSideNavShortcutEnabled)();
    const tooltipProps = (0, $cozmU.useMemo)(()=>{
        if (isFhsEnabled || (0, $iDrrr.fg)('platform-dst-keep-desired-fhs-features')) return {
            ...$ee8db6bac2a63753$var$toggleButtonTooltipOptions,
            shortcut: isShortcutEnabled ? (0, $8CGNp.sideNavToggleTooltipKeyboardShortcut) : undefined
        };
        return $ee8db6bac2a63753$var$toggleButtonTooltipOptions;
    }, [
        isFhsEnabled,
        isShortcutEnabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bZTfQ.IconButton), {
        appearance: "subtle",
        label: isSideNavExpanded ? collapseLabel : expandLabel,
        icon: icon,
        onClick: handleClick,
        onPointerEnter: handlePointerEnter,
        testId: testId,
        isTooltipDisabled: false,
        interactionName: interactionName,
        ref: setElement,
        tooltip: tooltipProps
    });
};
module.exports["SideNavToggleButton"] = $ee8db6bac2a63753$export$8bd77667631fec25;

});

parcelRegister("bZTfQ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1sCHt = parcelRequire("1sCHt");


var $6cyWf = parcelRequire("6cyWf");


var $hemOQ = parcelRequire("hemOQ");

const $0f0eeda6a04bd532$export$c25acd513dcc8062 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(4);
    const hasCustomTheme = (0, $6cyWf.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $hemOQ.ThemedIconButton) : (0, $1sCHt.default);
    let t0;
    if ($[0] !== Component || $[1] !== props || $[2] !== ref) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
            ref: ref,
            ...props
        });
        $[0] = Component;
        $[1] = props;
        $[2] = ref;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
} : (props, ref)=>{
    const hasCustomTheme = (0, $6cyWf.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $hemOQ.ThemedIconButton) : (0, $1sCHt.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
        ref: ref,
        ...props
    });
});
module.exports["IconButton"] = $0f0eeda6a04bd532$export$c25acd513dcc8062;

});

parcelRegister("hemOQ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lmzCg = parcelRequire("lmzCg");


var $lpNn5 = parcelRequire("lpNn5");


var $9GVkD = parcelRequire("9GVkD");


var $aXMFs = parcelRequire("aXMFs");


var $5dijw = parcelRequire("5dijw");

const $1521ff7d48cd2b50$export$d9c2d067feb61447 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? function ThemedIconButton(t0, ref) {
    const $ = (0, $bDgLe.c)(14);
    let Icon;
    let label;
    let props;
    let tooltip;
    if ($[0] !== t0) {
        ({ icon: Icon, label: label, tooltip: tooltip, ...props } = t0);
        $[0] = t0;
        $[1] = Icon;
        $[2] = label;
        $[3] = props;
        $[4] = tooltip;
    } else {
        Icon = $[1];
        label = $[2];
        props = $[3];
        tooltip = $[4];
    }
    const t1 = tooltip?.content ?? label;
    let t2;
    if ($[5] !== Icon || $[6] !== label || $[7] !== props || $[8] !== ref) {
        t2 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5dijw.ThemedPressable), {
                ...props,
                shape: "square",
                ref: (0, $lmzCg.default)([
                    ref,
                    triggerProps.ref
                ]),
                onClick: (event, analyticsEvent)=>{
                    props.onClick?.(event, analyticsEvent);
                    triggerProps?.onClick?.(event);
                },
                onMouseOver: (e)=>{
                    triggerProps.onMouseOver?.(e);
                    props.onMouseOver?.(e);
                },
                onMouseOut: (e_0)=>{
                    triggerProps.onMouseOut?.(e_0);
                    props.onMouseOut?.(e_0);
                },
                onMouseMove: (e_1)=>{
                    triggerProps.onMouseMove?.(e_1);
                    props.onMouseMove?.(e_1);
                },
                onMouseDown: (e_2)=>{
                    triggerProps.onMouseDown?.(e_2);
                    props.onMouseDown?.(e_2);
                },
                onFocus: (e_3)=>{
                    triggerProps.onFocus?.(e_3);
                    props.onFocus?.(e_3);
                },
                onBlur: (e_4)=>{
                    triggerProps.onBlur?.(e_4);
                    props.onBlur?.(e_4);
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aXMFs.default), {
                icon: Icon
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), null, label));
        $[5] = Icon;
        $[6] = label;
        $[7] = props;
        $[8] = ref;
        $[9] = t2;
    } else t2 = $[9];
    let t3;
    if ($[10] !== t1 || $[11] !== t2 || $[12] !== tooltip) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            ...tooltip,
            content: t1
        }, t2);
        $[10] = t1;
        $[11] = t2;
        $[12] = tooltip;
        $[13] = t3;
    } else t3 = $[13];
    return t3;
} : function ThemedIconButton({ icon: Icon, label: label, tooltip: tooltip, ...props }, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        ...tooltip,
        content: tooltip?.content ?? label
    }, (triggerProps)=>/**
     * The `aria-describedby` from `triggerProps` is intentionally not passed down,
     * because it would cause double announcements with the `VisuallyHidden` label.
     *
     * The `@atlaskit/button` IconButton uses the same approach.
     */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5dijw.ThemedPressable), {
            ...props,
            shape: "square",
            ref: (0, $lmzCg.default)([
                ref,
                triggerProps.ref
            ]),
            onClick: (event, analyticsEvent)=>{
                props.onClick?.(event, analyticsEvent);
                triggerProps?.onClick?.(event);
            },
            onMouseOver: (e)=>{
                triggerProps.onMouseOver?.(e);
                props.onMouseOver?.(e);
            },
            onMouseOut: (e_0)=>{
                triggerProps.onMouseOut?.(e_0);
                props.onMouseOut?.(e_0);
            },
            onMouseMove: (e_1)=>{
                triggerProps.onMouseMove?.(e_1);
                props.onMouseMove?.(e_1);
            },
            onMouseDown: (e_2)=>{
                triggerProps.onMouseDown?.(e_2);
                props.onMouseDown?.(e_2);
            },
            onFocus: (e_3)=>{
                triggerProps.onFocus?.(e_3);
                props.onFocus?.(e_3);
            },
            onBlur: (e_4)=>{
                triggerProps.onBlur?.(e_4);
                props.onBlur?.(e_4);
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aXMFs.default), {
            icon: Icon
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), null, label)));
});
module.exports["ThemedIconButton"] = $1521ff7d48cd2b50$export$d9c2d067feb61447;

});

parcelRegister("lu8mP", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dpsRj = parcelRequire("dpsRj");

const $50234bf2386dee1f$export$fb8fa9a80240785e = /*#__PURE__*/ (0, $cozmU.createContext)((0, $dpsRj.default));
module.exports["SideNavToggleButtonAttachRef"] = $50234bf2386dee1f$export$fb8fa9a80240785e;

});

parcelRegister("5Pqwh", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bB0i2 = parcelRequire("bB0i2");


var $kgGsB = parcelRequire("kgGsB");


var $1fHIr = parcelRequire("1fHIr");


var $liCgE = parcelRequire("liCgE");


var $6NDDH = parcelRequire("6NDDH");


var $eoCwK = parcelRequire("eoCwK");


var $jsuJ9 = parcelRequire("jsuJ9");


var $kdCH7 = parcelRequire("kdCH7");

/**
 * Namespaces to check for open layers that would interfere with the panel splitter.
 *
 * Placed outside the component for stability, as the list is used as an effect dependency.
 */ const $07b49ae768269ee7$var$openLayerNamespacesToCheck = [
    // The side nav panel splitter is layered above the side nav, so needs to be disabled when there are open popups in the side nav.
    (0, $liCgE.openLayerObserverSideNavNamespace),
    // The side nav panel splitter is layered above the top nav, so needs to be disabled when there are open popups in the top nav.
    (0, $liCgE.openLayerObserverTopNavStartNamespace),
    (0, $liCgE.openLayerObserverTopNavMiddleNamespace),
    (0, $liCgE.openLayerObserverTopNavEndNamespace)
];
/**
 * Returns whether there are any open popups in the side nav or top nav
 */ const $07b49ae768269ee7$var$useHasOpenPopupsInSideNavOrTopNav = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useHasOpenPopupsInSideNavOrTopNav() {
    const $ = (0, $bDgLe.c)(4);
    const isFhsEnabled = (0, $1fHIr.useIsFhsEnabled)();
    const openLayerObserver = (0, $kgGsB.useOpenLayerObserver)();
    const [hasOpenPopups, setHasOpenPopups] = (0, $cozmU.useState)(false);
    let t0;
    let t1;
    if ($[0] !== isFhsEnabled || $[1] !== openLayerObserver) {
        t0 = ()=>{
            if (!openLayerObserver || !isFhsEnabled) return;
            const updateState = function updateState() {
                if (!openLayerObserver) return;
                const hasAnyOpenLayers = $07b49ae768269ee7$var$openLayerNamespacesToCheck.some((namespace)=>openLayerObserver.getCount({
                        namespace: namespace,
                        type: "popup"
                    }) > 0);
                setHasOpenPopups(hasAnyOpenLayers);
            };
            updateState();
            const cleanups = $07b49ae768269ee7$var$openLayerNamespacesToCheck.map((namespace_0)=>openLayerObserver.onChange(updateState, {
                    namespace: namespace_0
                }));
            return function cleanupHook() {
                cleanups.forEach($07b49ae768269ee7$var$_temp);
            };
        };
        t1 = [
            isFhsEnabled,
            openLayerObserver
        ];
        $[0] = isFhsEnabled;
        $[1] = openLayerObserver;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
    return hasOpenPopups;
} : function useHasOpenPopupsInSideNavOrTopNav() {
    const isFhsEnabled = (0, $1fHIr.useIsFhsEnabled)();
    const openLayerObserver = (0, $kgGsB.useOpenLayerObserver)();
    // Setting the initial state to false, as it is unlikely that there would be any open popups when the app starts.
    const [hasOpenPopups, setHasOpenPopups] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!openLayerObserver || !isFhsEnabled) return;
        function updateState() {
            if (!openLayerObserver) return;
            const hasAnyOpenLayers = $07b49ae768269ee7$var$openLayerNamespacesToCheck.some((namespace)=>openLayerObserver.getCount({
                    namespace: namespace,
                    type: 'popup'
                }) > 0);
            setHasOpenPopups(hasAnyOpenLayers);
        }
        // Initial check. We do this _in case_ a popup is already open when the component mounts.
        updateState();
        // Subscribe to each namespace
        const cleanups = $07b49ae768269ee7$var$openLayerNamespacesToCheck.map((namespace_0)=>openLayerObserver.onChange(updateState, {
                namespace: namespace_0
            }));
        return function cleanupHook() {
            cleanups.forEach((cleanup)=>cleanup());
        };
    }, [
        isFhsEnabled,
        openLayerObserver
    ]);
    return hasOpenPopups;
};
function $07b49ae768269ee7$var$_temp(cleanup) {
    return cleanup();
}
const $07b49ae768269ee7$export$5f595addf4e50d58 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { label: label, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, testId: testId, shouldCollapseOnDoubleClick: t1, tooltipContent: tooltipContent } = t0;
    const shouldCollapseOnDoubleClick = t1 === undefined ? true : t1;
    const context = (0, $cozmU.useContext)((0, $kdCH7.PanelSplitterContext));
    (0, $bB0i2.default)(context?.panelId === (0, $liCgE.sideNavPanelSplitterId), "SideNavPanelSplitter must be rendered as a child of <SideNav />.");
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            trigger: "double-click"
        };
        $[0] = t2;
    } else t2 = $[0];
    const toggleSideNav = (0, $6NDDH.useToggleSideNav)(t2);
    const isFhsEnabled = (0, $1fHIr.useIsFhsEnabled)();
    const hasOpenLayersInSideNavOrTopNav = $07b49ae768269ee7$var$useHasOpenPopupsInSideNavOrTopNav();
    if (hasOpenLayersInSideNavOrTopNav && isFhsEnabled) return null;
    const t3 = shouldCollapseOnDoubleClick ? toggleSideNav : undefined;
    const t4 = shouldCollapseOnDoubleClick ? tooltipContent : undefined;
    let t5;
    if ($[1] !== label || $[2] !== onResizeEnd || $[3] !== onResizeStart || $[4] !== t4 || $[5] !== testId) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jsuJ9.PanelSplitter), {
            label: label,
            onResizeStart: onResizeStart,
            onResizeEnd: onResizeEnd,
            testId: testId,
            tooltipContent: t4
        });
        $[1] = label;
        $[2] = onResizeEnd;
        $[3] = onResizeStart;
        $[4] = t4;
        $[5] = testId;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] !== t3 || $[8] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eoCwK.OnDoubleClickContext).Provider, {
            value: t3
        }, t5);
        $[7] = t3;
        $[8] = t5;
        $[9] = t6;
    } else t6 = $[9];
    return t6;
} : ({ label: label, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, testId: testId, shouldCollapseOnDoubleClick: shouldCollapseOnDoubleClick = true, tooltipContent: tooltipContent })=>{
    const context = (0, $cozmU.useContext)((0, $kdCH7.PanelSplitterContext));
    (0, $bB0i2.default)(context?.panelId === (0, $liCgE.sideNavPanelSplitterId), 'SideNavPanelSplitter must be rendered as a child of <SideNav />.');
    const toggleSideNav = (0, $6NDDH.useToggleSideNav)({
        trigger: 'double-click'
    });
    const isFhsEnabled = (0, $1fHIr.useIsFhsEnabled)();
    // The logic and state for disabling the panel splitter when there are open popups
    // in the side nav or top nav is being placed here, instead of in `SideNav`, to prevent
    // re-rendering the side nav anytime the number of open popups changes.
    const hasOpenLayersInSideNavOrTopNav = $07b49ae768269ee7$var$useHasOpenPopupsInSideNavOrTopNav();
    if (hasOpenLayersInSideNavOrTopNav && isFhsEnabled) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eoCwK.OnDoubleClickContext).Provider, {
        value: shouldCollapseOnDoubleClick ? toggleSideNav : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jsuJ9.PanelSplitter), {
        label: label,
        onResizeStart: onResizeStart,
        onResizeEnd: onResizeEnd,
        testId: testId,
        tooltipContent: // Only displaying the tooltip if double click to collapse is enabled.
        // Otherwise, we would be displaying a tooltip with "Double click to collapse", when it actually won't.
        shouldCollapseOnDoubleClick ? tooltipContent : undefined
    }));
};
module.exports["SideNavPanelSplitter"] = $07b49ae768269ee7$export$5f595addf4e50d58;

});


//# sourceMappingURL=object-preview-panel.e7d40df5.js.map
